export const LABEL_TITLE_QR = 'Label.Title.QR';
export const LABEL_TITLE_VERIFICATION = 'Label.Title.Verification';
export const LABEL_TITLE_LOCKED_ACCOUNT = 'LockedAccount.title';
export const LABEL_TEXT_EMAIL = 'Label.Text.Email';
export const LABEL_TEXT_PASSWORD = 'Label.Text.Password';
export const LABEL_TEXT_WELCOME = 'Label.Text.Welcome';
export const LABEL_TEXT_LOGIN = 'Label.Field.Login';
export const LABEL_TEXT_DOWNLOAD = 'Label.Text.Download';
export const LABEL_TEXT_PRINT = 'Label.Text.Print';
export const LABEL_TEXT_OR = 'LockedAccount.or';
export const LABEL_TEXT_FORGOT_PASSWORD = 'Label.Field.Forgot.Password';
export const LABEL_TEXT_QR_STEP1 = 'Label.Text.Qr.Step1';
export const LABEL_TEXT_QR_STEP2 = 'Label.Text.Qr.Step2';
export const LABEL_TEXT_QR_STEP3 = 'Label.Text.Qr.Step3';
export const LABEL_TEXT_QR_SUBMIT = 'Label.Text.Qr.Submit';
export const LABEL_TEXT_VERIFICATION_SUBMIT = 'Label.Text.Verification.Submit';
export const LABEL_TEXT_VERIFICATION_SUBTITLE =
    'Label.Text.Verification.Subtitle';
export const LABEL_TEXT_VERIFICATION_REMEMBER_ME =
    'Label.Text.Verification.Remember.Me';
export const LABEL_TEXT_ACCOUNT_LOCKED = 'LockedAccount.description';
export const LABEL_TEXT_ACCOUNT_CONTACT = 'LockedAccount.firstOption';
export const LABEL_TEXT_ACCOUNT_BRAND = 'LockedAccount.secondOption';
export const LABEL_TEXT_ACCOUNT_PHONE = 'LockedAccount.phone';
export const LABEL_TEXT_ACCOUNT_HOURS = 'LockedAccount.schedule';
export const LABEL_TEXT_ACCOUNT_HOURS_WEEKEND = 'LockedAccount.weekendSchedule';
export const LABEL_TEXT_ACCOUNT_LINK = 'LockedAccount.link';
export const LABEL_TEXT_ERROR_ATTEMPT_TITLE = 'Label.Text.Error.Attempt.Title';
export const LABEL_TEXT_ERROR_ATTEMPT_SUBTITLE =
    'Label.Text.Error.Attempt.Subtitle';
export const LABEL_PASSWORD_ERROR_ATTEMPT_SUBTITLE =
    'Label.Password.Error.Attempt.Subtitle';

export const LABEL_FIELD_APPNOTIFICATION_TITLE =
    'Label.Field.AppNotification.Title';
export const LABEL_FIELD_APPNOTIFICATION_TEXT =
    'Label.Field.AppNotification.Text';
export const LABEL_FIELD_APPNOTIFICATION_RELOAD =
    'Label.Field.AppNotification.Reload';
export const LABEL_FIELD_APPNOTIFICATION_AVOID =
    'Label.Field.AppNotification.Avoid';

export const LABEL_FIELD_ERROR_INVALID_EMAIL = 'Label.Field.Error.ValidEmail';
export const LABEL_FIELD_ERROR_REQUIRED = 'Label.Field.Error.Required';
export const LABEL_FIELD_ERROR_REQUIRED_VALID =
    'Label.Field.Error.RequiredValid';
export const LABEL_FIELD_ERROR_REQUEST_SERVICE = 'Label.Field.Error.Service';
export const LABEL_FIELD_ERROR_INVALID_OR_INCORRECT_EMAIL =
    'Label.Field.Error.Invalid.Email';
export const LABEL_FIELD_ERROR_INVALID_OR_INCORRECT_PASSWORD =
    'Label.Field.Error.Invalid.Password';
export const LABEL_FIELD_PRYVACY_NOTICE = 'Label.Field.Privacy.Notice';
export const LABEL_FIELD_CONTACT_US = 'Label.Field.Contact.Us';
export const LABEL_FIELD_USAGE_AGREEMENT = 'Label.Field.UsageAgreement';
export const LABEL_FIELD_PRIVACY_POLICY = 'Label.Field.PirvacyPolicy';
export const LABEL_FIELD_ERROR_INVALID_OR_EXPIRED_CODE =
    'Label.Field.Error.Invalid.Code';
export const LABEL_FIELD_ERROR_INVALID_PHONE =
    'Label.Field.Error.Invalid.Phone';

export const LABEL_TEXT_FUNDING_SEARCH_ERROR_NO_RESULTS =
    'Label.Text.FundingSearch.Error.NoResults';
export const LABEL_TEXT_FUNDING_SEARCH_ERROR_SUGGESTION =
    'Label.Text.FundingSearch.Error.Suggestion';
export const LABEL_TEXT_MENU_HOME = 'Label.Text.Menu.Home';
export const LABEL_TEXT_MENU_CREDIT = 'Label.Text.Menu.Credit';
export const LABEL_TEXT_MENU_CREDIT_APP = 'Label.Text.Menu.Credit.Application';
export const LABEL_TEXT_MENU_CREDIT_STATUS = 'Label.Text.Menu.Credit.Status';
export const LABEL_TEXT_MENU_FUNDING = 'Label.Text.Menu.Funding';
export const LABEL_TEXT_MENU_FUNDING_APP =
    'Label.Text.Menu.Funding.Application';
export const LABEL_TEXT_MENU_FUNDING_STATUS = 'Label.Text.Menu.Funding.Status';
export const LABEL_TEXT_MENU_FUNDING_DOCUMENTS =
    'Label.Text.Menu.Funding.Documents';
export const LABEL_TEXT_MENU_EFT_NOTIFICATIONS = 'Label.Text.Menu.Funding.Eft';
export const LABEL_TEXT_MENU_RESERVES = 'Label.Text.Menu.Funding.Reserves';
export const LABEL_TEXT_MENU_PAYOFF = 'Label.Text.Menu.Payoff';
export const LABEL_TEXT_MENU_PAYOFF_APP = 'Label.Text.Menu.Payoff.Application';
export const LABEL_TEXT_MENU_PAYOFF_STATUS = 'Label.Text.Menu.Payoff.Status';
export const LABEL_TEXT_MENU_PAYOFF_DOCUMENTS =
    'Label.Text.Menu.Payoff.Documents';
export const LABEL_TEXT_MENU_RESOURCES = 'Label.Text.Menu.Resources';
export const LABEL_TEXT_MENU_RESOURCES_APP =
    'Label.Text.Menu.Resources.Application';
export const LABEL_TEXT_MENU_RESOURCES_STATUS =
    'Label.Text.Menu.Resources.Status';
export const LABEL_TEXT_MENU_RESOURCES_DOCUMENTS =
    'Label.Text.Menu.Resources.Documents';
export const LABEL_TEXT_MENU_RESOURCES_BULLETINS =
    'Label.Text.Menu.Resources.Bulletins';
export const LABEL_TEXT_MENU_PAYMENTS = 'Label.Text.Menu.Payments';
export const LABEL_TEXT_MENU_PAYMENTS_MAKE = 'Label.Text.Menu.PaymentsMake';
export const LABEL_TEXT_MENU_PAYMENTS_PENDING =
    'Label.Text.Menu.PaymentsPending';
export const LABEL_TEXT_MENU_PAYMENTS_HISTORY =
    'Label.Text.Menu.PaymentsHistory';
export const LABEL_TEXT_MENU_SERVICE_LOANER = 'Label.Text.Menu.Service.Loaner';
export const LABEL_TEXT_MENU_SYSTEM_ADMIN = 'Label.Text.Menu.System.Admin';
export const LABEL_TEXT_MENU_DEALER_RENTAL = 'Label.Text.Menu.Dealer.Rental';
export const LABEL_TEXT_MENU_MANAGE_USER = 'Label.Text.Menu.Manage.User';
export const LABEL_TEXT_MENU_PAYOFF_QUOTES = 'Label.Text.Menu.Payoff.Quotes';
export const LABEL_TEXT_MENU_LANGUAGE = 'Label.Text.Menu.Language';
export const LABEL_TEXT_MENU_PROFILE_LOGOUT = 'Label.Text.Menu.Profile.Logout';
export const LABEL_TEXT_MENU_PROFILE_SETTINGS =
    'Label.Text.Menu.Profile.Settings';
export const LABEL_TEXT_MENU_PROFILE = 'Label.Text.Menu.Profile';
export const LABEL_TEXT_MENU_PORTFOLIO = 'Label.Text.Menu.Portfolio';
export const LABEL_TEXT_MENU_MY_CUSTOMERS = 'Label.Text.Menu.MyCustomers';
export const LABEL_TEXT_MENU_PROGRAM_ELIGIBILITY =
    'Label.Text.Menu.ProgramEligibility';
export const LABEL_TEXT_MENU_PROFILE_LANG_ENGLISH =
    'Label.Text.Menu.Lang.English';
export const LABEL_TEXT_MENU_PROFILE_LANG_FRENCH =
    'Label.Text.Menu.Lang.French';
export const LABEL_TEXT_BRAND_AUDI_FINANCIAL_SERVICES =
    'Label.Text.Brand.AudiFinancialServices';
export const LABEL_TEXT_BRAND_VOLKSWAGEN_FINANCIAL_SERVICES =
    'Label.Text.Brand.VolkswagenFinancialServices';
export const LABEL_TEXT_BRAND_DUCATI_FINANCIAL_SERVICES =
    'Label.Text.Brand.DucatiFinancialServices';
export const LABEL_TEXT_MAINTENANCE = 'Label.Text.Maintenance';
export const LABEL_TEXT_IN_VALID_DEALER_PORTAL =
    'Label.Text.inValidDealerPortal';
export const LABEL_TEXT_IN_VALID_DEALER_PORTAL_US =
    'Label.Text.inValidDealerPortalUS';
export const LABEL_TEXT_SHOWING = 'Label.Text.Showing';
export const LABEL_TEXT_RESULT_OF_TABLE = 'Label.Text.ResultOfTable';
export const LABEL_TEXT_RESULT_PER_PAGE = 'Label.Text.ResultsPerPage';
export const LABEL_TEXT_DASH_DISTRICT = 'Label.Text.District';
export const LABEL_TEXT_DASH_SELECT = 'Label.Text.Select';
export const LABEL_TEXT_DASH_MAIN_ACC = 'Label.Text.MainAccount';
export const LABEL_TEXT_DASH_SEC_ACC = 'Label.Text.SecundaryAccount';
export const LABEL_TEXT_DASH_DEALERSHIP = 'Label.Text.Dealerships';
export const LABEL_TEXT_DASH_NORESULTS = 'Label.Text.NoResults';

export const LABEL_STATUS_SUMMARY = 'StatusSummary.Label.Status';
export const LABEL_STATUS_SUMMARY_INFO = 'StatusSummary.Label.Info';
export const LABEL_STATUS_SUMMARY_CREDIT_BT =
    'StatusSummary.Label.Credit.button';
export const LABEL_STATUS_SUMMARY_FUNDING_BT =
    'StatusSummary.Label.Funding.button';
export const LABEL_STATUS_SUMMARY_FUNDING_PRODUCT =
    'StatusSummary.Label.Funding.Product';
export const LABEL_STATUS_SUMMARY_CREDIT_PRODUCT =
    'StatusSummary.Label.Credit.Product';
export const LABEL_STATUS_SUMMARY_ITEM_APPROVED =
    'StatusSummary.Label.Item.Approved';
export const LABEL_STATUS_SUMMARY_ITEM_UNABLETOFUND =
    'StatusSummary.Label.Item.UnableToFund';
export const LABEL_STATUS_SUMMARY_ITEM_WITHDRAWN =
    'StatusSummary.Label.Item.Withdrawn';
export const LABEL_STATUS_SUMMARY_ITEM_RECEIVED =
    'StatusSummary.Label.Item.Received';
export const LABEL_STATUS_SUMMARY_ITEM_BOOKED =
    'StatusSummary.Label.Item.Booked';
export const LABEL_STATUS_SUMMARY_ITEM_PENDING =
    'StatusSummary.Label.Item.Pending';
export const LABEL_STATUS_SUMMARY_ITEM_CONDITIONED =
    'StatusSummary.Label.Item.Conditioned';
export const LABEL_STATUS_SUMMARY_ITEM_DECLINED =
    'StatusSummary.Label.Item.Declined';

export const LABEL_EFT_HEADER = 'EFT.Label.Header';
export const EFT_DISCLAIMER_CONFIDENTIAL = 'EFT.Disclaimer.Confidential';
export const EFT_THANKS = 'EFT.Thanks';
export const EFT_VW = 'EFT.Vw';
export const EFT_AUDI = 'EFT.Audi';
export const EFT_DISCLAIMER_FUNDS = 'EFT.Disclaimer.Funds';
export const EFT_NO_RESPONSE = 'EFT.NoResponse';
export const EFT_SELECT_OTHER = 'EFT.SelectOther';
export const EFT_DAYS_WITH_NOTIFICATIONS = 'EFT.DaysWithNotifications';
export const EFT_DEPOSIT_PART1 = 'EFT.DepositPart1';
export const EFT_AT = 'EFT.At';
export const EFT_DEPOSIT_PART2 = 'EFT.DepositPart2';
export const EFT_REMITTANCE_INFO = 'EFT.RemittanceInfo';
export const EFT_RESERVE_AMOUNT = 'EFT.ReserveAmount';
export const EFT_AMOUNT_PAID = 'EFT.AmountPaid';
export const EFT_TOTAL = 'EFT.Total';

export const LABEL_BULLETINS_NAME = 'Bulletins.Label.Name';
export const LABEL_BULLETINS_POSTED = 'Bulletins.Label.Posted';
export const LABEL_BULLETINS_EFFECTIVE_DATES = 'Bulletins.Label.Effective.Days';
export const LABEL_BULLETINS_TITLE = 'Bulletins.Label.Title';
export const LABEL_BULLETINS_ARCHIVE = 'Bulletins.Label.Archive';
export const LABEL_BULLETINS_ALL = 'Bulletins.Label.All';
export const LABEL_BULLETINS_HEADER = 'Bulletins.Header.Label';
export const LABEL_BULLETINS_FILTER_ALL = 'Bulletins.Label.Filter.All';
export const LABEL_BULLETINS_FILTER_ACTIVE = 'Bulletins.Label.Filter.Active';
export const LABEL_BULLETINS_FILTER_EXPIRED = 'Bulletins.Label.Filter.Expired';
export const LABEL_BULLETINS_SEARCH = 'Bulletins.Label.Search';
export const LABEL_BULLETINS_SEARCH_DESCRIPTION =
    'Bulletins.Label.SearchDescription';
export const LABEL_BULLETINS_SEARCH_PLACEHOLDER =
    'Bulletins.Label.SearchPlaceholder';
export const LABEL_BULLETINS_SEARCH_BUTTON = 'Bulletins.Label.SearchButton';
export const LABEL_BULLETINS_STATUS = 'Bulletins.Label.Status';
export const LABEL_BULLETINS_TYPE = 'Bulletins.Label.Type';
export const LABEL_BULLETINS_TYPE_PLACEHOLDER =
    'Bulletins.Label.TypePlaceholder';
export const LABEL_BULLETINS_DATE_RANGE = 'Bulletins.Label.DateRange';
export const LABEL_BULLETINS_CLEAR_FILTERS = 'Bulletins.Label.ClearFilters';
export const LABEL_BULLETINS_CLEAR_SEARCH = 'Bulletins.Label.ClearSearch';
export const LABEL_BULLETINS_NO_RESULTS = 'Bulletins.Label.NoResults';
export const LABEL_BULLETINS_TYPE_ALL = 'Bulletins.Label.TypeAll';
export const LABEL_BULLETINS_TYPE_LEASE = 'Bulletins.Label.TypeLease';
export const LABEL_BULLETINS_TYPE_RETAIL = 'Bulletins.Label.TypeRetail';
export const LABEL_BULLETINS_TYPE_BALLOON = 'Bulletins.Label.TypeBalloon';
export const LABEL_BULLETINS_TYPE_MISCELLANEOUS =
    'Bulletins.Label.TypeMiscellaneous';
export const LABEL_BULLETINS_TYPE_INFORMATIONAL =
    'Bulletins.Label.TypeInformational';
export const LABEL_BULLETINS_TYPE_PROGRAMS = 'Bulletins.Label.TypePrograms';
export const LABEL_BULLETINS_COLUMN_NUMBER = 'Bulletins.Label.ColumnNumber';
export const LABEL_BULLETINS_COLUMN_TITLE = 'Bulletins.Label.ColumnTitle';
export const LABEL_BULLETINS_COLUMN_START_DATE =
    'Bulletins.Label.ColumnStartDate';
export const LABEL_BULLETINS_COLUMN_END_DATE = 'Bulletins.Label.ColumnEndDate';
export const LABEL_BULLETINS_COLUMN_MODIFY_DATE =
    'Bulletins.Label.ColumnModifyDate';
export const LABEL_BULLETINS_SORT_ASCENDING = 'Bulletins.Label.SortAscending';
export const LABEL_BULLETINS_SORT_DESCENDING = 'Bulletins.Label.SortDescending';
export const LABEL_BULLETINS_SORT_TOGGLE = 'Bulletins.Label.SortToggle';
export const LABEL_HANDBOOK_LABEL_LINK = 'Handbook.Label.Link';
export const LABEL_HANDBOOK_TITLE = 'Handbook.Label.Title';
export const LABEL_HANDBOOK_TEXT_AUDI = 'Handbook.Label.Text.Audi';
export const LABEL_HANDBOOK_TEXT_VW = 'Handbook.Label.Text.Vw';
export const LABEL_HANDBOOK_TEXT_DUCATI = 'Handbook.Label.Text.Ducati';
export const LABEL_MODAL_INACTIVITY_TITLE = 'Modal.Inactivity.Title';
export const LABEL_MODAL_INACTIVITY_CONTENT = 'Modal.Inactivity.Content';
export const LABEL_MODAL_INACTIVITY_BTN_LOGOUT = 'Modal.Inactivity.Logout';
export const LABEL_MODAL_INACTIVITY_BTN_CONTINUE = 'Modal.Inactivity.Continue';

export const CONTACT_INFO_HEADER_LABEL = 'Contact.Info.Header.Label';
export const CONTACT_INFO_HEADER_LINK_LABEL = 'Contact.Info.Header.Link.Label';
export const CONTACT_INFO_ADMIN_LABEL = 'Contact.Info.Admin.Label';
export const CONTACT_INFO_PHONE_LABEL = 'Contact.Info.Phone.Label';
export const CONTACT_INFO_EMAIL_LABEL = 'Contact.Info.Email.Label';
export const CONTACT_INFO_FAX_LABEL = 'Contact.Info.Fax.Label';
export const CONTACT_INFO_DEALER_LINE_LABEL = 'Contact.Info.Dealer.Label';
export const CONTACT_INFO_CUSTOMER_CARE_LABEL = 'Contact.Info.Customer.Label';

export const DEPARTMENT_LABEL_1 = 'Department.label_1';
export const DEPARTMENT_LABEL_2 = 'Department.label_2';
export const DEPARTMENT_CREDIT = 'Department.data.credit';
export const DEPARTMENT_FUNDING = 'Department.data.funding';
export const DEPARTMENT_LEASE = 'Department.data.lease_end';
export const DEPARTMENT_CUSTOMER_SERVICE = 'Department.data.customer_service';
export const DEPARTMENT_DEALER_SUPPORT = 'Department.data.dealer_support';
export const DEPARTMENT_DE_TECH_SUPPORT = 'Department.data.de_tech_support';

export const NO_DATA_AVAILABLE = 'Label.No.Data';
export const LABEL_SL_HEADER = 'ServiceLoanerInventory.Label.Header';
export const LABEL_DR_HEADER = 'DealerRentalInventory.Label.Header';
export const INVENTORY_TABLE_VIN = 'InventoryTable.VIN';
export const INVENTORY_TABLE_VEHICLE = 'InventoryTable.VEHICLE';
export const INVENTORY_TABLE_STATUS = 'InventoryTable.STATUS';
export const INVENTORY_TABLE_MATURITY_DATE = 'InventoryTable.MATURITY_DATE';
export const INVENTORY_TABLE_PURCHASE_PRICE = 'InventoryTable.PURCHASE_PRICE';
//detailsView
// export const DETAILS_VIEW_TITLE_DEALER_RENTAL = 'DetailsView.titleDealerRental';
export const TITLE_DEALER_RENTAL = 'DetailsView.titleDealerRental';
export const TITLE_SERVICE_LOANER = 'DetailsView.titleServiceLoaner';
export const VIN = 'DetailsView.vin';
export const MAKE = 'DetailsView.make';
export const MODELCODE = 'DetailsView.modelCode';
export const COLOR = 'DetailsView.color';
export const OPTIONS = 'DetailsView.options';
export const STOCKNO = 'DetailsView.stockNo';
export const MILEAGE = 'DetailsView.mileage';
export const MILEAGE_DATE = 'DetailsView.mileageDate';
export const NOTES = 'DetailsView.notes';
export const ACCOUNT_INFO = 'DetailsView.headingAccountInfo';
export const LEASE_CONTRACT_ID = 'DetailsView.leaseContractID';
export const IN_SERVICE_DATE = 'DetailsView.inServiceDate';
export const LEASE_TERM = 'DetailsView.leaseTerm';
export const MATURITY_DATE = 'DetailsView.maturityDate';
export const SPECIAL_PGM_CODE = 'DetailsView.specialProgramCode';
export const LENGTH_OF_SERVICE = 'DetailsView.lengthOfService';
export const REMAINING_PAYMENTS = 'DetailsView.remainingPayments';
export const STATUS = 'DetailsView.status';
export const MSRP = 'DetailsView.MSRP';
export const MONTHLY_PAYMENT = 'DetailsView.monthlyPayment';
export const CURRENTPURCHAERPRICE = 'DetailsView.currentPurchasePrice';
export const REMAINING_PAYMENTS_ON_LEASE =
    'DetailsView.remainingPaymentsOnLease';
export const BUYOUT_AT_TERM = 'DetailsView.buyoutAtTerm';
export const ACTIVE = 'DetailsView.statusValues.active';
export const MATURITY = 'DetailsView.statusValues.maturity';
export const BEYOND_TERM = 'DetailsView.statusValues.beyondTerm';
export const FORCE_GROUND = 'DetailsView.statusValues.forceGround';
export const MONTHS = 'DetailsView.months';

// commonLabels
export const EMPTY_FIELD = 'CommonLabels.emptyField';
export const PRINT = 'CommonLabels.print';
export const API_FAILURE = 'ErrorMessages.apiFailureError';
export const NOT_NUMBER = 'ErrorMessages.notNumberError';
export const FUNDING_STATUS_HEADER_LABEL = 'Funding.Status.Header.Label';
export const FUNDING_STATUS_TABLE_HEADER_NAME =
    'Funding.Status.Table.Header.Name';
export const FUNDING_STATUS_TABLE_HEADER_APPLICANT_NAME =
    'Funding.Status.Table.Header.ApplicantName';
export const FUNDING_STATUS_TABLE_HEADER_ACCOUNT_NUMBER =
    'Funding.Status.Table.Header.AccountNumber';
export const FUNDING_STATUS_TABLE_HEADER_STATUS =
    'Funding.Status.Table.Header.Status';
export const FUNDING_STATUS_TABLE_HEADER_COLLATERAL =
    'Funding.Status.Table.Header.Collateral';
export const FUNDING_STATUS_TABLE_HEADER_VIN =
    'Funding.Status.Table.Header.Vin';
export const FUNDING_STATUS_TABLE_HEADER_DATE =
    'Funding.Status.Table.Header.Date';
export const FUNDING_STATUS_TABLE_FUNCTION_RESET_FILTER =
    'Funding.Status.Table.Function.ResetFilter';
export const FUNDING_STATUS_TABLE_FUNCTION_RECEIVED_DATE =
    'Funding.Status.Table.Function.ReceivedDate';
export const FUNDING_STATUS_TABLE_FUNCTION_ALL_STATUSES =
    'Funding.Status.Table.Function.AllStatuses';
export const FUNDING_STATUS_TABLE_FUNCTION_SEARCH_BY =
    'Funding.Status.Table.Function.SearchBy';
export const FUNDING_STATUS_TABLE_FUNCTION_SEARCH_BY_CA =
    'Funding.Status.Table.Function.SearchByCa';
export const FUNDING_STATUS_TABLE_OPTION_DAYS =
    'Funding.Status.Table.Option.Days';
export const FUNDING_STATUS_DETAILS_HEADER = 'Funding.Status.Details.Header';
export const FUNDING_STATUS_DETAILS_APPLICANT_HEADER =
    'Funding.Status.Details.Applicant.Header';
export const FUNDING_STATUS_DETAILS_APPLICANT_NAME =
    'Funding.Status.Details.Applicant.Name';
export const FUNDING_STATUS_DETAILS_APPLICANT_ADDRESS =
    'Funding.Status.Details.Applicant.Address';
export const FUNDING_STATUS_DETAILS_APPLICANT_HOME =
    'Funding.Status.Details.Applicant.Home';
export const FUNDING_STATUS_DETAILS_APPLICANT_MOBILE =
    'Funding.Status.Details.Applicant.Mobile';
export const FUNDING_STATUS_DETAILS_APPLICANT_SSN =
    'Funding.Status.Details.Applicant.Ssn';
export const FUNDING_STATUS_DETAILS_LOAN_AMOUNT =
    'Funding.Status.Details.Loan.Amount';
export const FUNDING_STATUS_DETAILS_LOAN_TYPE =
    'Funding.Status.Details.Loan.Type';
export const FUNDING_STATUS_DETAILS_LOAN_TERM =
    'Funding.Status.Details.Loan.Term';
export const FUNDING_STATUS_DETAILS_LOAN_MONTHS =
    'Funding.Status.Details.Loan.Months';
export const FUNDING_STATUS_DETAILS_LOAN_BULLETIN =
    'Funding.Status.Details.Loan.Bulletin';
export const FUNDING_STATUS_DETAILS_LOAN_TOTAL =
    'Funding.Status.Details.Loan.Total';
export const FUNDING_STATUS_DETAILS_PACKAGE_HEADER =
    'Funding.Status.Details.Package.Header';
export const FUNDING_STATUS_DETAILS_PACKAGE_APPLICATION_NUMBER =
    'Funding.Status.Details.Package.ApplicationNumber';
export const FUNDING_STATUS_DETAILS_PACKAGE_CONTRACTID =
    'Funding.Status.Details.Package.ContractId';
export const FUNDING_STATUS_DETAILS_PACKAGE_STATUS =
    'Funding.Status.Details.Package.Status';
export const FUNDING_STATUS_DETAILS_HISTORY_HEADER =
    'Funding.Status.Details.History.Header';
export const FUNDING_STATUS_DETAILS_HISTORY_AUDITOR =
    'Funding.Status.Details.History.Auditor';
export const FUNDING_STATUS_DETAILS_HISTORY_NOTES =
    'Funding.Status.Details.History.Notes';
export const FUNDING_STATUS_DETAILS_MISSING_ITEMS =
    'Funding.Status.Details.History.Missing';
export const FUNDING_STATUS_DETAILS_DATE_AT = 'Funding.Status.Details.Date.At';

//DEALER MANAGEMENT EXPORTS
export const DEALER_MGMT_HEADER_LABEL = 'Dealer.Management.Users.Label.Header';
export const DEALER_MGMT_ADD_BUTTON_LABEL =
    'Dealer.Management.Users.Label.AddButton';
export const DEALER_MGMT_USERS_NUMBER_LABEL =
    'Dealer.Management.Users.Label.UsersNumber';
export const DEALER_MGMT_TABLE_HEADER_NAME =
    'Dealer.Management.Table.Header.Name';
export const DEALER_MGMT_TABLE_HEADER_EMAIL =
    'Dealer.Management.Table.Header.Email';
export const DEALER_MGMT_TABLE_HEADER_ADMIN =
    'Dealer.Management.Table.Header.Admin';
export const DEALER_MGMT_TABLE_HEADER_STATUS =
    'Dealer.Management.Table.Header.Status';
export const DEALER_MGMT_TABLE_HEADER_DEALERS =
    'Dealer.Management.Table.Header.Dealers';
export const DEALER_MGMT_TABLE_MENU_EDIT = 'Dealer.Management.Table.Menu.Edit';
export const DEALER_MGMT_TABLE_MENU_DELETEMFA =
    'Dealer.Management.Table.Menu.DeleteMFA';
export const DEALER_MGMT_TABLE_MENU_DEACTIVATE =
    'Dealer.Management.Table.Menu.Deactivate';
export const DEALER_MGMT_TABLE_MENU_ACTIVATE =
    'Dealer.Management.Table.Menu.Activate';
export const DEALER_MGMT_DEACTIVATE_MODAL_TITLE =
    'Dealer.Management.Table.Modal.Deactivate.Title';
export const DEALER_MGMT_DELETE_MODAL_TITLE =
    'Dealer.Management.Table.Modal.Delete.Title';
export const DEALER_MGMT_DELETEMFA_MODAL_TITLE =
    'Dealer.Management.Table.Modal.DeleteMFA.Title';
export const DEALER_MGMT_UNLOCK_MODAL_TITLE =
    'Dealer.Management.Table.Modal.Unlock.Title';
export const DEALER_MGMT_RESETPASS_MODAL_TITLE =
    'Dealer.Management.Table.Modal.RestPassLink.Title';
export const DEALER_MGMT_DEACTIVATE_MODAL_DESCRIPTION =
    'Dealer.Management.Table.Modal.Deactivate.Description';
export const DEALER_MGMT_ACTIVATE_MODAL_DESCRIPTION =
    'Dealer.Management.Table.Modal.Activate.Description';
export const DEALER_MGMT_DELETE_MODAL_DESCRIPTION =
    'Dealer.Management.Table.Modal.Delete.Description';
export const DEALER_MGMT_DELETEMFA_MODAL_DESCRIPTION =
    'Dealer.Management.Table.Modal.DeleteMFA.Description';
export const DEALER_MGMT_UNLOCK_MODAL_DESCRIPTION =
    'Dealer.Management.Table.Modal.Unlock.Description';
export const DEALER_MGMT_RESETPASS_MODAL_DESCRIPTION =
    'Dealer.Management.Table.Modal.RestPassLink.Description';
export const DEALER_MGMT_DEACTIVATE_MODAL_CONFIRM_BUTTON =
    'Dealer.Management.Table.Modal.Deactivate.Confirm';
export const DEALER_MGMT_ACTIVATE_MODAL_CONFIRM_BUTTON =
    'Dealer.Management.Table.Modal.Activate.Confirm';
export const DEALER_MGMT_DELETE_MODAL_CONFIRM_BUTTON =
    'Dealer.Management.Table.Modal.Delete.Confirm';
export const DEALER_MGMT_DELETEMFA_MODAL_CONFIRM_BUTTON =
    'Dealer.Management.Table.Modal.DeleteMFA.Confirm';
export const DEALER_MGMT_UNLOCK_MODAL_CONFIRM_BUTTON =
    'Dealer.Management.Table.Modal.Unlock.Confirm';
export const DEALER_MGMT_RESETPASS_MODAL_CONFIRM_BUTTON =
    'Dealer.Management.Table.Modal.RestPassLink.Confirm';

export const DEALER_MGMT_TABLE_MENU_DELETE =
    'Dealer.Management.Table.Menu.Delete';
export const DEALER_MGMT_TABLE_USER_STATUS_ACTIVE =
    'Dealer.Management.Table.UserStatus.Active';
export const DEALER_MGMT_TABLE_USER_STATUS_INACTIVE =
    'Dealer.Management.Table.UserStatus.Inactive';

export const DEALER_MGMT_TABLE_USER_MESSAGES_SUCCESSMFA_DELETED =
    'Dealer.Management.Table.Messages.SuccessMFADeleted';
export const DEALER_MGMT_TABLE_USER_MESSAGES_ERRORMFA_DELETED =
    'Dealer.Management.Table.Messages.ErrorMFADeleted';

//REGISTRATION SUCCESS
export const REGISTRATION_SUCCESS_LABEL_TITLE = 'RegistrationSuccess.Title';
export const REGISTRATION_SUCCESS_LABEL_SUBTITLE =
    'RegistrationSuccess.Subtitle';
export const REGISTRATION_SUCCESS_LABEL_TEXT = 'RegistrationSuccess.Text';
export const REGISTRATION_SUCCESS_LABEL_BUTTON = 'RegistrationSuccess.Button';

//ACCOUNT REGISTRATION
export const ACCOUNT_REGISTRATION_TITLE = 'AccountRegistration.Title';
export const ACCOUNT_REGISTRATION_DESCRIPTION =
    'AccountRegistration.Description';
export const ACCOUNT_REGISTRATION_LABEL_PASSWORD =
    'AccountRegistration.Label.Password';
export const ACCOUNT_REGISTRATION_LABEL_PASSWORD_CONFIRM =
    'AccountRegistration.Label.Password_Confirm';
export const ACCOUNT_REGISTRATION_LABEL_PASSWORD_NOTE_HEADING =
    'AccountRegistration.Label.Password_Note_Heading';
export const ACCOUNT_REGISTRATION_LABEL_PASSWORD_NOTE1 =
    'AccountRegistration.Label.Password_Note1';
export const ACCOUNT_REGISTRATION_LABEL_PASSWORD_NOTE2 =
    'AccountRegistration.Label.Password_Note2';
export const ACCOUNT_REGISTRATION_LABEL_PASSWORD_NOTE3 =
    'AccountRegistration.Label.Password_Note3';
export const ACCOUNT_REGISTRATION_LABEL_AGREEMENT =
    'AccountRegistration.Label.Agreement';
export const ACCOUNT_REGISTRATION_LABEL_USAGE_AGREEMENT =
    'AccountRegistration.Label.UseAgreement';
export const ACCOUNT_REGISTRATION_BUTTON_CONTINUE =
    'AccountRegistration.Button.Continue';
export const ACCOUNT_REGISTRATION_LABEL_FIELD_REQUIRED =
    'AccountRegistration.Label.Field_Required';
export const ACCOUNT_REGISTRATION_LABEL_NOTIFICATION_ERROR =
    'AccountRegistration.Label.Notification_Error';
export const ACCOUNT_REGISTRATION_LABEL_PASSWORD_ERROR_MATCH =
    'AccountRegistration.Label.Notification_Error_Password_Match';
export const ACCOUNT_REGISTRATION_LABEL_PASSWORD_ERROR_REGEX =
    'AccountRegistration.Label.Notification_Error_Password_Regex';

//ADD NEW USER
export const ADD_NEW_USER_HEADER_BACK = 'AddNewUser.Header.Back';
export const ADD_NEW_USER_BUTTON_ADD = 'AddNewUser.Button.Submit';
export const ADD_NEW_USER_BODY_HEADER = 'AddNewUser.Body.Header';
export const ADD_NEW_USER_BODY_ALLFIELDS = 'AddNewUser.Body.AllFields';
export const ADD_NEW_USER_FORM_LABEL_EMAIL = 'AddNewUser.Body.Form.Label.Email';
export const ADD_NEW_USER_FORM_LABEL_FIRSTNAME =
    'AddNewUser.Body.Form.Label.FirstName';
export const ADD_NEW_USER_FORM_LABEL_LASTNAME =
    'AddNewUser.Body.Form.Label.LastName';
export const ADD_NEW_USER_FORM_LABEL_PHONE = 'AddNewUser.Body.Form.Label.Phone';
export const ADD_NEW_USER_DEALERSHIP_HEADER =
    'AddNewUser.Body.Dealership.Header';
export const ADD_NEW_USER_DEALERSHIP_REQUIRED =
    'AddNewUser.Body.Dealership.Required';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PLACEHOLDER =
    'AddNewUser.Body.Dealership.Select.Placeholder';
export const ADD_NEW_USER_DEALERSHIP_SELECT_MODIFIER =
    'AddNewUser.Body.Dealership.Select.Modifier';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_ADMIN =
    'AddNewUser.Body.Dealership.Select.Permission.Admin';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_CREDITAPPLICATION =
    'AddNewUser.Body.Dealership.Select.Permission.CreditApplication';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_APPLICATIONSTATUS =
    'AddNewUser.Body.Dealership.Select.Permission.ApplicationStatus';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_FUNDINGSTATUS =
    'AddNewUser.Body.Dealership.Select.Permission.FundingStatus';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_PAYOFFQUOTES =
    'AddNewUser.Body.Dealership.Select.Permission.PayoffQuotes';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_BULLETINS =
    'AddNewUser.Body.Dealership.Select.Permission.Bulletins';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_DEALERRESERVEEFT =
    'AddNewUser.Body.Dealership.Select.Permission.DealerReservesEFT';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_DEALERRENTAL =
    'AddNewUser.Body.Dealership.Select.Permission.DealerRental';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_SERVICELOANER =
    'AddNewUser.Body.Dealership.Select.Permission.ServiceLoaner';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_TITLE_MATURITY =
    'AddNewUser.Body.Dealership.Select.Permission.Title.Maturity';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_MATURITY_ASSIGN =
    'AddNewUser.Body.Dealership.Select.Permission.Maturity.Assign';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_MATURITY_VIEW =
    'AddNewUser.Body.Dealership.Select.Permission.Maturity.View';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_TITLE_QUICKFUND =
    'AddNewUser.Body.Dealership.Select.Permission.Title.QuickFund';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_QUICKFUND_ASSIGN =
    'AddNewUser.Body.Dealership.Select.Permission.QuickFund.Assign';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_QUICKFUND_VIEW =
    'AddNewUser.Body.Dealership.Select.Permission.QuickFund.View';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_TITLE_ELECTRONIC_PAYMENTS =
    'AddNewUser.Body.Dealership.Select.Permission.Title.Electronic.Payments';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_SUBMIT_ELECTRONIC_PAYMENT =
    'AddNewUser.Body.Dealership.Select.Permission.Submit.Electronic.Payment';
export const ADD_NEW_USER_DEALERSHIP_SELECT_PERMISSION_SUBMIT_APPROVED_ELECTRONIC_PAYMENT =
    'AddNewUser.Body.Dealership.Select.Permission.Submit.Approve.Electronic.Payment';
export const ADD_NEW_USER_NOTIFICATION_SUCCESS =
    'AddNewUser.Notification.Success';
export const ADD_NEW_USER_NOTIFICATION_ERROR_REQUEST =
    'AddNewUser.Notification.ErrorRequest';
export const ADD_NEW_USER_MODAL_TITLE = 'AddNewUser.Modal.Title';
export const ADD_NEW_USER_MODAL_CONTENT = 'AddNewUser.Modal.Content';
export const ADD_NEW_USER_MODAL_LABEL_BUTTON_CANCEL =
    'AddNewUser.Modal.Label.Button.Cancel';
export const ADD_NEW_USER_MODAL_LABEL_BUTTON_CONFIRM =
    'AddNewUser.Modal.Label.Button.Confirm';

//ISM ADD NEW USER
export const ISM_ADD_NEW_USER_HEADER_BACK = 'ISMAddNewUser.Header.Back';
export const ISM_ADD_NEW_USER_BODY_HEADER = 'ISMAddNewUser.Body.Header';
export const ISM_ADD_NEW_USER_BODY_ALLFIELDS = 'ISMAddNewUser.Body.AllFields';
export const ISM_ADD_NEW_USER_FORM_LABEL_PHONE =
    'ISMAddNewUser.Body.Form.Label.Phone';
export const ISM_ADD_NEW_USER_FORM_LABEL_EMAIL =
    'ISMAddNewUser.Body.Form.Label.Email';
export const ISM_ADD_NEW_USER_FORM_LABEL_FIRSTNAME =
    'ISMAddNewUser.Body.Form.Label.FirstName';
export const ISM_ADD_NEW_USER_FORM_LABEL_LASTNAME =
    'ISMAddNewUser.Body.Form.Label.LastName';
export const ISM_ADD_NEW_USER_DEALERSHIP_HEADER =
    'ISMAddNewUser.Body.Dealership.Header';
export const ISM_ADD_NEW_USER_DEALERSHIP_DESCRIPTION =
    'ISMAddNewUser.Body.Dealership.Description';
export const ISM_ADD_NEW_USER_DEALERSHIP_SELECT_PLACEHOLDER =
    'ISMAddNewUser.Body.Dealership.Select.Placeholder';
export const ISM_ADD_NEW_USER_DEALERSHIP_SELECT_MODIFIER =
    'ISMAddNewUser.Body.Dealership.Select.Modifier';
export const ISM_ADD_NEW_USER_PERMISSIONS_HEADER =
    'ISMAddNewUser.Body.Permissions.Header';
export const ISM_ADD_NEW_USER_PERMISSIONS_DESCRIPTION =
    'ISMAddNewUser.Body.Permissions.Description';
export const ISM_ADD_NEW_USER_PERMISSIONS_INTERNAL_TOOLS =
    'ISMAddNewUser.Body.Permissions.InternalTools';
export const ISM_ADD_NEW_USER_PERMISSIONS_DEALER_TOOLS =
    'ISMAddNewUser.Body.Permissions.DealerTools';
export const ISM_ADD_NEW_USER_PERMISSIONS_CONTENT_TOOLS =
    'ISMAddNewUser.Body.Permissions.ContentTools';
export const ISM_ADD_NEW_USER_PERMISSIONS_VEHICLE_MAINTENANCE =
    'ISMAddNewUser.Body.Permissions.VehicleMaintenance';
export const ISM_ADD_NEW_USER_PERMISSIONS_INTERNAL_SECURITY =
    'ISMAddNewUser.Body.Permissions.InternalSecurityMaintenance';
export const ISM_ADD_NEW_USER_PERMISSIONS_FIELD_USER_MGMT =
    'ISMAddNewUser.Body.Permissions.FieldUserManagement';
export const ISM_ADD_NEW_USER_PERMISSIONS_DEALER_ACTIVATION =
    'ISMAddNewUser.Body.Permissions.DealerActivation';
export const ISM_ADD_NEW_USER_PERMISSIONS_DEALER_SECURITY =
    'ISMAddNewUser.Body.Permissions.DealerSecurityMaintenance';
export const ISM_ADD_NEW_USER_PERMISSIONS_CV_FORM =
    'ISMAddNewUser.Body.Permissions.CvFormMaintenance';
export const ISM_ADD_NEW_USER_PERMISSIONS_EDOCS =
    'ISMAddNewUser.Body.Permissions.EDocsMaintenance';
export const ISM_ADD_NEW_USER_PERMISSIONS_NEWS_STORIES =
    'ISMAddNewUser.Body.Permissions.NewsStories';
export const ISM_ADD_NEW_USER_PERMISSIONS_DISTRIBUTION_RULE =
    'ISMAddNewUser.Body.Permissions.DistributionRuleManagement';
export const ISM_ADD_NEW_USER_PERMISSIONS_ONLINE_BULLETINS =
    'ISMAddNewUser.Body.Permissions.OnlineBulletins';
export const ISM_ADD_NEW_USER_PERMISSIONS_STATIC_CONTENT =
    'ISMAddNewUser.Body.Permissions.StaticContentMaintenance';
export const ISM_ADD_NEW_USER_PERMISSIONS_VEHICLE_MAINTENANCE_PERM =
    'ISMAddNewUser.Body.Permissions.VehicleMaintenancePermission';
export const ISM_ADD_NEW_USER_BUTTON_SUBMIT = 'ISMAddNewUser.Button.Submit';
export const ISM_ADD_NEW_USER_BUTTON_CANCEL = 'ISMAddNewUser.Button.Cancel';
export const ISM_ADD_NEW_USER_NOTIFICATION_SUCCESS =
    'ISMAddNewUser.Notification.Success';
export const ISM_ADD_NEW_USER_NOTIFICATION_ERROR =
    'ISMAddNewUser.Notification.ErrorRequest';
export const ISM_ADD_NEW_USER_MODAL_TITLE = 'ISMAddNewUser.Modal.Title';
export const ISM_ADD_NEW_USER_MODAL_CONTENT = 'ISMAddNewUser.Modal.Content';
export const ISM_ADD_NEW_USER_MODAL_CANCEL =
    'ISMAddNewUser.Modal.Label.Button.Cancel';
export const ISM_ADD_NEW_USER_MODAL_CONFIRM =
    'ISMAddNewUser.Modal.Label.Button.Confirm';

//ISM UPDATE USER
export const ISM_UPDATE_USER_HEADER_BACK = 'ISMUpdateUser.Header.Back';
export const ISM_UPDATE_USER_PROFILE_HEADER = 'ISMUpdateUser.Profile.Header';
export const ISM_UPDATE_USER_PHONE_DESCRIPTION =
    'ISMUpdateUser.Phone.Description';
export const ISM_UPDATE_USER_BUTTON_CANCEL = 'ISMUpdateUser.Button.Cancel';
export const ISM_UPDATE_USER_MENU_SUSPEND = 'ISMUpdateUser.Menu.Suspend';
export const ISM_UPDATE_USER_MENU_REINSTATE = 'ISMUpdateUser.Menu.Reinstate';
export const ISM_UPDATE_USER_MENU_DELETE = 'ISMUpdateUser.Menu.Delete';
export const ISM_UPDATE_USER_NOTIFICATION_SUCCESS_SAVE =
    'ISMUpdateUser.Notification.Success.Save';
export const ISM_UPDATE_USER_NOTIFICATION_SUCCESS_REINSTATE =
    'ISMUpdateUser.Notification.Success.Reinstate';
export const ISM_UPDATE_USER_NOTIFICATION_SUCCESS_SUSPEND =
    'ISMUpdateUser.Notification.Success.Suspend';
export const ISM_UPDATE_USER_NOTIFICATION_ERROR =
    'ISMUpdateUser.Notification.ErrorRequest';
export const ISM_UPDATE_USER_MODAL_TITLE = 'ISMUpdateUser.Modal.Title';
export const ISM_UPDATE_USER_MODAL_CONTENT = 'ISMUpdateUser.Modal.Content';
export const ISM_UPDATE_USER_MODAL_CANCEL =
    'ISMUpdateUser.Modal.Label.Button.Cancel';
export const ISM_UPDATE_USER_MODAL_CONFIRM =
    'ISMUpdateUser.Modal.Label.Button.Confirm';
export const ISM_UPDATE_USER_ACTION_MODAL_TITLE_SUSPEND =
    'ISMUpdateUser.ActionModal.Title.Suspend';
export const ISM_UPDATE_USER_ACTION_MODAL_TITLE_REINSTATE =
    'ISMUpdateUser.ActionModal.Title.Reinstate';
export const ISM_UPDATE_USER_ACTION_MODAL_TITLE_DELETE =
    'ISMUpdateUser.ActionModal.Title.Delete';
export const ISM_UPDATE_USER_ACTION_MODAL_BODY_SUSPEND =
    'ISMUpdateUser.ActionModal.Body.Suspend';
export const ISM_UPDATE_USER_ACTION_MODAL_BODY_REINSTATE =
    'ISMUpdateUser.ActionModal.Body.Reinstate';
export const ISM_UPDATE_USER_ACTION_MODAL_BODY_DELETE =
    'ISMUpdateUser.ActionModal.Body.Delete';
export const ISM_UPDATE_USER_ACTION_MODAL_CONFIRM =
    'ISMUpdateUser.ActionModal.Confirm';

//EDIT USER
export const EDIT_USER_SETTINGS_HEADER = 'EditUser.Settings.Header';
export const EDIT_USER_SETTINGS_PROFILE = 'EditUser.Settings.Profile';
export const EDIT_USER_SETTINGS_PASSWORD = 'EditUser.Settings.Password';
export const EDIT_USER_NOTIFICATION_ERROR_REQUEST =
    'EditUser.Notification.Error.Request';
export const EDIT_USER_NOTIFICATION_SUCCESS_REQUEST =
    'EditUser.Notification.Success.Request';
export const EDIT_USER_NOTIFICATION_SUCCESS_ACTIVATION =
    'EditUser.Notification.Success.Activated';
export const EDIT_USER_NOTIFICATION_SUCCESS_DEACTIVATION =
    'EditUser.Notification.Success.Deactivated';
export const EDIT_USER_NOTIFICATION_SUCCESS_PASSWORDRESETLINK =
    'EditUser.Notification.Success.PasswordResetLink';
export const EDIT_USER_NOTIFICATION_ERROR_PASSWORDRESETLINK_LOCKED =
    'EditUser.Notification.Error.PasswordResetLink.Locked';
export const EDIT_USER_NOTIFICATION_SUCCESS_UNLOCKED =
    'EditUser.Notification.Success.Unlocked';
export const EDIT_USER_NOTIFICATION_WARNING_LOCKED =
    'EditUser.Notification.Warning.Locked';
export const EDIT_USER_PROFILE_HEADER = 'EditUser.Profile.Header';
export const EDIT_USER_PASSWORD_HEADER = 'EditUser.Password.Header';
export const EDIT_USER_MODAL_CONTENT = 'EditUser.Modal.Content';
export const EDIT_USER_BUTTON_DISCARD_LABEL =
    'EditUser.Profile.Button.Label.Discard';
export const EDIT_USER_BUTTON_SAVE_LABEL = 'EditUser.Profile.Button.Label.Save';
export const EDIT_USER_BUTTON_RESET_PWD_LABEL =
    'EditUser.Profile.Button.Label.ResetPwd';
export const EDIT_USER_BUTTON_UNLOCK = 'EditUser.Profile.Button.Label.Unlock';
// Delete User
export const NOTIFICATION_SUCCESS_DELETION = 'DeleteUser.Notification.Success';
export const VEHICLEINFO_TITLE = 'VehicleInformation.Title';
export const VEHICLEINFO_TYPE_LABEL = 'VehicleInformation.VehicleType.Label';
export const VEHICLEINFO_TYPE_NEW = 'VehicleInformation.VehicleType.New';
export const VEHICLEINFO_TYPE_PRE = 'VehicleInformation.VehicleType.PreOwned';
export const VEHICLEINFO_TYPE_CPO = 'VehicleInformation.VehicleType.CPO';
export const VEHICLEINFO_TYPE_DEMO = 'VehicleInformation.VehicleType.Demo';
export const VEHICLEINFO_MAKE_LABEL = 'VehicleInformation.Make.Label';
export const VEHICLEINFO_MAKE_DEAFULT = 'VehicleInformation.Make.Default';
export const VEHICLEINFO_YEAR_LABEL = 'VehicleInformation.Year.Label';
export const VEHICLEINFO_YEAR_DEAFULT = 'VehicleInformation.Year.Default';
export const VEHICLEINFO_MODEL_LABEL = 'VehicleInformation.Model.Label';
export const VEHICLEINFO_MODEL_DEAFULT = 'VehicleInformation.Model.Default';
export const VEHICLEINFO_BODY_LABEL = 'VehicleInformation.Body.Label';
export const VEHICLEINFO_BODY_DEAFULT = 'VehicleInformation.Body.Default';
export const VEHICLEINFO_MILEAGE_LABEL = 'VehicleInformation.Mielage.Label';
export const VEHICLEINFO_MILEAGE_ERROR = 'VehicleInformation.Mielage.Error';
export const VEHICLEINFO_VIN_LABEL = 'VehicleInformation.Vin.Label';
export const VEHICLEINFO_VIN_ERROR = 'VehicleInformation.Vin.Error';
export const VEHICLEINFO_OPTION_AUCTION = 'VehicleInformation.Auction';

export const CREDIT_APP_FINANCE_TITLE = 'CreditApp.Finance.Label.Title';
export const CREDIT_APP_FINANCE_TYPE_LABEL = 'CreditApp.Finance.Type.Label';
export const CREDIT_APP_FINANCE_TYPE_TOOLTIP = 'CreditApp.Finance.Type.Tooltip';

export const CREDIT_APP_FINANCE_TERM_LABEL = 'CreditApp.Finance.Term.Label';
export const CREDIT_APP_FINANCE_TERM_TOOLTIP = 'CreditApp.Finance.Term.Tooltip';
export const CREDIT_APP_FINANCE_TERM_ERROR = 'CreditApp.Finance.Term.Error';

export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_LABEL =
    'CreditApp.Finance.SpecialProgram.Label';

export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_LABEL_2 =
    'CreditApp.Finance.SpecialProgram.Label_2';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_TOOLTIP =
    'CreditApp.Finance.SpecialProgram.Tooltip';
export const CREDIT_APP_SUBMIT_BUTTON = 'CreditApp.Submit';
export const CREDIT_APP_SUBMIT_UPDATES_BUTTON = 'CreditApp.SubmitUpdates';
export const CREDIT_APP_SAVE_BUTTON = 'CreditApp.Save';
export const CREDIT_APP_EDIT_LABEL = 'CreditApp.Edit';
export const CREDIT_APP_PRINT_BUTTON = 'CreditApp.Print';

export const CREDIT_APP_MODAL_SUCCESS_TITLE = 'CreditApp.Modals.Success.Title';
export const CREDIT_APP_MODAL_SUCCESS_SUBTITLE =
    'CreditApp.Modals.Success.Subtitle';
export const CREDIT_APP_MODAL_SUCCESS_CANCEL =
    'CreditApp.Modals.Success.Buttons.Cancel';
export const CREDIT_APP_MODAL_SUCCESS_NEXT =
    'CreditApp.Modals.Success.Buttons.Next';
export const CREDIT_APP_MODAL_ERROR_TITLE = 'CreditApp.Modals.Error.Title';
export const CREDIT_APP_MODAL_ERROR_SUBTITLE =
    'CreditApp.Modals.Error.Subtitle';
export const CREDIT_APP_MODAL_ERROR_NEXT =
    'CreditApp.Modals.Error.Buttons.Next';
export const CREDIT_APP_MODAL_PROCESSING_TITLE =
    'CreditApp.Modals.Processing.Title';
export const CREDIT_APP_MODAL_PROCESSING_SUBTITLE =
    'CreditApp.Modals.Processing.Subtitle';
export const CREDIT_APP_MODAL_TYPE_TITLE = 'CreditApp.Modals.Type.Title';
export const CREDIT_APP_MODAL_TYPE_SUBTITLE = 'CreditApp.Modals.Type.Subtitle';
export const CREDIT_APP_MODAL_TYPE_TEXT = 'CreditApp.Modals.Type.Text';
export const CREDIT_APP_MODAL_TYPE_BACK = 'CreditApp.Modals.Type.Back';
export const CREDIT_APP_MODAL_TYPE_NEW = 'CreditApp.Modals.Type.New';
export const CREDIT_APP_MODAL_NAME_TITLE = 'CreditApp.Modals.Name.Title';
export const CREDIT_APP_MODAL_NAME_SUBTITLE = 'CreditApp.Modals.Name.Subtitle';
export const CREDIT_APP_MODAL_NAME_CANCEL = 'CreditApp.Modals.Name.Cancel';
export const CREDIT_APP_MODAL_NAME_CHANGE = 'CreditApp.Modals.Name.Change';
export const CREDIT_APP_MODAL_NAME_CORRECT = 'CreditApp.Modals.Name.Correct';

export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_BROKER =
    'CreditApp.Finance.SpecialProgram.Item.BrokerDeal';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_FIRST_TIME =
    'CreditApp.Finance.SpecialProgram.Item.FirstTimeBuyer';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_COLLEGE_GRAD =
    'CreditApp.Finance.SpecialProgram.Item.CollegeGrad';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_FOREIGN_BUS =
    'CreditApp.Finance.SpecialProgram.Item.ForeignBusPlan';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_FOREIGN_STUDENT =
    'CreditApp.Finance.SpecialProgram.Item.ForeignStudent';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_RATE_PROTECTION =
    'CreditApp.Finance.SpecialProgram.Item.RateProtection';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_MULTI_SEC_DEPOSIT =
    'CreditApp.Finance.SpecialProgram.Item.MultiSecDeposit';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_PRE_PAY_LEASE =
    'CreditApp.Finance.SpecialProgram.Item.PrePayLease';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_LEASE_TRANSFER =
    'CreditApp.Finance.SpecialProgram.Item.LeaseTransfer';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_DEF_PAYMENT =
    'CreditApp.Finance.SpecialProgram.Item.DefPayment';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_VGCA_EMPLOYEE =
    'CreditApp.Finance.SpecialProgram.Item.VGCAEmployee';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_FOREIGN_WORKER =
    'CreditApp.Finance.SpecialProgram.Item.ForeignWorker';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_AMBASSADOR_PROGRAM =
    'CreditApp.Finance.SpecialProgram.Item.AmbassadorProgram';
export const CREDIT_APP_FINANCE_SPECIAL_PROGRAM_ITEM_PERMANENT_RESIDENT =
    'CreditApp.Finance.SpecialProgram.Item.PermanentResident';

export const CREDIT_APP_FINANCE_MSRP_LABEL = 'CreditApp.Finance.MSRP.Label';
export const CREDIT_APP_FINANCE_MSRP_ERROR = 'CreditApp.Finance.MSRP.Error';

export const CREDIT_APP_FINANCE_CASH_PRICE_LABEL =
    'CreditApp.Finance.CashPrice.Label';
export const CREDIT_APP_FINANCE_CASH_PRICE_TOOLTIP =
    'CreditApp.Finance.CashPrice.Tooltip';
export const CREDIT_APP_FINANCE_CASH_PRICE_ERROR =
    'CreditApp.Finance.CashPrice.Error';

export const CREDIT_APP_FINANCE_GROSS_CAP_LABEL =
    'CreditApp.Finance.Cap.Gross.Label';
export const CREDIT_APP_FINANCE_GROSS_CAP_ERROR =
    'CreditApp.Finance.Cap.Gross.Error';

export const CREDIT_APP_FINANCE_NET_CAP_PRICE_LABEL =
    'CreditApp.Finance.Cap.Net.Label';
export const CREDIT_APP_FINANCE_NET_CAP_TOOLTIP =
    'CreditApp.Finance.Cap.Net.Tooltip';
export const CREDIT_APP_FINANCE_NET_CAP_ERROR =
    'CreditApp.Finance.Cap.Net.Error';

export const CREDIT_APP_FINANCE_DOWN_PAYMENT_LABEL =
    'CreditApp.Finance.DownPayment.Label';
export const CREDIT_APP_FINANCE_DOWN_PAYMENT_TOOLTIP =
    'CreditApp.Finance.DownPayment.Tooltip';
export const CREDIT_APP_FINANCE_DOWN_PAYMENT_ERROR =
    'CreditApp.Finance.DownPayment.Error';

export const CREDIT_APP_TRADE_IN_AMOUNT_PAYMENT_LABEL =
    'CreditApp.Finance.TradeIn.Amount.Label';
export const CREDIT_APP_TRADE_IN_AMOUNT_PAYMENT_TOOLTIP =
    'CreditApp.Finance.TradeIn.Amount.Tooltip';
export const CREDIT_APP_TRADE_IN_AMOUNT_PAYMENT_ERROR =
    'CreditApp.Finance.TradeIn.Amount.Error';
export const CREDIT_APP_TRADE_IN_AMOUNT_PAYMENT_ERROR1 =
    'CreditApp.Finance.TradeIn.Amount.Error1';

export const CREDIT_APP_TRADE_IN_YEAR_LABEL =
    'CreditApp.Finance.TradeIn.Year.Label';
export const CREDIT_APP_TRADE_IN_YEAR_ERROR =
    'CreditApp.Finance.TradeIn.Year.Error';

export const CREDIT_APP_TRADE_IN_MAKE_LABEL =
    'CreditApp.Finance.TradeIn.Make.Label';
export const CREDIT_APP_TRADE_IN_MODEL_LABEL =
    'CreditApp.Finance.TradeIn.Model.Label';
export const CREDIT_APP_TRADE_IN_BODY_LABEL =
    'CreditApp.Finance.TradeIn.Body.Label';

export const CREDIT_APP_FINANCE_MONTHLY_PAY_LABEL =
    'CreditApp.Finance.MonthlyPayment.Label';

export const CREDIT_APP_FINANCE_MONTHLY_PAY_TOOLTIP =
    'CreditApp.Finance.MonthlyPayment.Tooltip';

export const TYPE_OPTION_LEASE = 'CreditApp.Finance.Type.Options.Lease';
export const TYPE_OPTION_LOAN = 'CreditApp.Finance.Type.Options.Loan';
export const TYPE_OPTION_VWSELECT = 'CreditApp.Finance.Type.Options.VWSelect';
export const TYPE_OPTION_DRIVER = 'CreditApp.Finance.Type.Options.Driver';

export const CREDIT_APPLICANT_TITLE = 'CreditApp.Applicant.Title';
export const CREDIT_APPLICANT_FIRSTNAME_LABEL =
    'CreditApp.Applicant.FirstName.Label';
export const CREDIT_APPLICANT_FIRSTNAME_ERROR =
    'CreditApp.Applicant.FirstName.Error';
export const CREDIT_APPLICANT_MI_LABEL = 'CreditApp.Applicant.MI.Label';
export const CREDIT_APPLICANT_MI_ERROR = 'CreditApp.Applicant.MI.Error';
export const CREDIT_APPLICANT_LASTNAME_LABEL =
    'CreditApp.Applicant.LastName.Label';
export const CREDIT_APPLICANT_LASTNAME_ERROR =
    'CreditApp.Applicant.LastName.Error';
export const CREDIT_APPLICANT_IDNUMBER_US_LABEL =
    'CreditApp.Applicant.IdentificationNumber.USA.Label';
export const CREDIT_APPLICANT_IDNUMBER_US_BUSINESS_LABEL =
    'CreditApp.Applicant.IdentificationNumber.USA.BusinessLabel';
export const CREDIT_APPLICANT_IDNUMBER_US_ERROR =
    'CreditApp.Applicant.IdentificationNumber.USA.Error';
export const CREDIT_APPLICANT_IDNUMBER_US_BUSINESS_ERROR =
    'CreditApp.Applicant.IdentificationNumber.USA.BusinessError';
export const CREDIT_APPLICANT_IDNUMBER_CA_LABEL =
    'CreditApp.Applicant.IdentificationNumber.CA.Label';
export const CREDIT_APPLICANT_IDNUMBER_CA_ERROR =
    'CreditApp.Applicant.IdentificationNumber.CA.Error';
export const CREDIT_APPLICANT_BIRTHDATE_LABEL =
    'CreditApp.Applicant.BirthDate.Label';
export const CREDIT_APPLICANT_BIRTHDATE_ERROR =
    'CreditApp.Applicant.BirthDate.Error';
export const CREDIT_APPLICANT_ADDRESS1_LABEL =
    'CreditApp.Applicant.AddressLine1.Label';
export const CREDIT_APPLICANT_ADDRESS1_ERROR =
    'CreditApp.Applicant.AddressLine1.Error';
export const CREDIT_APPLICANT_ADDRESS2_LABEL =
    'CreditApp.Applicant.AddressLine2Label';
export const CREDIT_APPLICANT_CITY_LABEL = 'CreditApp.Applicant.City.Label';
export const CREDIT_APPLICANT_CITY_ERROR = 'CreditApp.Applicant.City.Error';
export const CREDIT_APPLICANT_STATE_US_LABEL =
    'CreditApp.Applicant.State.USA.Label';
export const CREDIT_APPLICANT_STATE_CA_LABEL =
    'CreditApp.Applicant.State.CA.Label';
export const CREDIT_APPLICANT_STATE_US_DEFAULT =
    'CreditApp.Applicant.State.USA.Default';
export const CREDIT_APPLICANT_STATE_CA_DEFAULT =
    'CreditApp.Applicant.State.CA.Default';
export const CREDIT_APPLICANT_STATE_CA_AB =
    'CreditApp.Applicant.State.CA.stateAB';
export const CREDIT_APPLICANT_STATE_CA_BC =
    'CreditApp.Applicant.State.CA.stateBC';
export const CREDIT_APPLICANT_STATE_CA_MB =
    'CreditApp.Applicant.State.CA.stateMB';
export const CREDIT_APPLICANT_STATE_CA_NB =
    'CreditApp.Applicant.State.CA.stateNB';
export const CREDIT_APPLICANT_STATE_CA_NL =
    'CreditApp.Applicant.State.CA.stateNL';
export const CREDIT_APPLICANT_STATE_CA_NS =
    'CreditApp.Applicant.State.CA.stateNS';
export const CREDIT_APPLICANT_STATE_CA_NT =
    'CreditApp.Applicant.State.CA.stateNT';
export const CREDIT_APPLICANT_STATE_CA_NU =
    'CreditApp.Applicant.State.CA.stateNU';
export const CREDIT_APPLICANT_STATE_CA_ON =
    'CreditApp.Applicant.State.CA.stateON';
export const CREDIT_APPLICANT_STATE_CA_PE =
    'CreditApp.Applicant.State.CA.statePE';
export const CREDIT_APPLICANT_STATE_CA_QC =
    'CreditApp.Applicant.State.CA.stateQC';
export const CREDIT_APPLICANT_STATE_CA_SK =
    'CreditApp.Applicant.State.CA.stateSK';
export const CREDIT_APPLICANT_STATE_CA_YT =
    'CreditApp.Applicant.State.CA.stateYT';
export const CREDIT_APPLICANT_ZIP_US_LABEL =
    'CreditApp.Applicant.Zip.USA.Label';
export const CREDIT_APPLICANT_ZIP_US_ERROR =
    'CreditApp.Applicant.Zip.USA.Error';
export const CREDIT_APPLICANT_ZIP_CA_LABEL = 'CreditApp.Applicant.Zip.CA.Label';
export const CREDIT_APPLICANT_ZIP_CA_ERROR = 'CreditApp.Applicant.Zip.CA.Error';
export const CREDIT_APPLICANT_RESIDENCE_LABEL =
    'CreditApp.Applicant.Residence.Label';
export const CREDIT_APPLICANT_RESIDENCE_OPTIONOWN =
    'CreditApp.Applicant.Residence.optionOwn';
export const CREDIT_APPLICANT_RESIDENCE_OPTIONRENT =
    'CreditApp.Applicant.Residence.optionRent';
export const CREDIT_APPLICANT_RESIDENCE_OPTIONPARENT =
    'CreditApp.Applicant.Residence.optionParent';
export const CREDIT_APPLICANT_ADRESSYEAR_LABEL =
    'CreditApp.Applicant.AddressTimeYear.Label';
export const CREDIT_APPLICANT_ADRESSYEAR_ERROR =
    'CreditApp.Applicant.AddressTimeYear.Error';
export const CREDIT_APPLICANT_ADRESSMONTH_LABEL =
    'CreditApp.Applicant.AddressTimeMonth.Label';
export const CREDIT_APPLICANT_ADRESSMONTH_ERROR =
    'CreditApp.Applicant.AddressTimeMonth.Error';
export const CREDIT_APPLICANT_RENT_LABEL = 'CreditApp.Applicant.RentLabel';
export const CREDIT_APPLICANT_HOUSING_LABEL =
    'CreditApp.Applicant.MonthHousingLabel';
export const CREDIT_APPLICANT_MORGAGE_LABEL =
    'CreditApp.Applicant.MonthMorgageLabel';
export const CREDIT_APPLICANT_PHONE_NOTE_US =
    'CreditApp.Applicant.PhoneNote.USA.Label';
export const CREDIT_APPLICANT_PHONE_NOTE_CA =
    'CreditApp.Applicant.PhoneNote.CA.Label';
export const CREDIT_APPLICANT_HOMEPHONE_LABEL =
    'CreditApp.Applicant.HomePhone.Label';
export const CREDIT_APPLICANT_HOMEPHONE_ERROR =
    'CreditApp.Applicant.HomePhone.Error';
export const CREDIT_APPLICANT_WORKPHONE_LABEL =
    'CreditApp.Applicant.Workphone.Label';
export const CREDIT_APPLICANT_WORKPHONE_ERROR =
    'CreditApp.Applicant.Workphone.Error';
export const CREDIT_APPLICANT_CELLPHONE_LABEL =
    'CreditApp.Applicant.Cellphone.Label';
export const CREDIT_APPLICANT_CELLPHONE_ERROR =
    'CreditApp.Applicant.Cellphone.Error';
export const CREDIT_APPLICANT_PHONE_ERROR = 'CreditApp.Applicant.Phone.Error';
export const CREDIT_APPLICANT_EMAIL_LABEL = 'CreditApp.Applicant.Email.Label';
export const CREDIT_APPLICANT_EMAIL_ERROR = 'CreditApp.Applicant.Email.Error';
export const CREDIT_APPLICANT_PREVACC_LABEL =
    'CreditApp.Applicant.PreviousAccount.Label';
export const CREDIT_APPLICANT_PREVACC_ERROR =
    'CreditApp.Applicant.PreviousAccount.Error';
export const CREDIT_APPLICANT_COPY_ADDRESS =
    'CreditApp.Applicant.copyAddressVerbiage';
export const CREDIT_APPLICANT_RELATION_TITLE =
    'CreditApp.Applicant.Relationship.Title';
export const CREDIT_APPLICANT_RELATION_NONE =
    'CreditApp.Applicant.Relationship.None';
export const CREDIT_APPLICANT_RELATION_AUNT =
    'CreditApp.Applicant.Relationship.Aunt';
export const CREDIT_APPLICANT_RELATION_BOYFRIEND =
    'CreditApp.Applicant.Relationship.Boyfriend';
export const CREDIT_APPLICANT_RELATION_BROTHER =
    'CreditApp.Applicant.Relationship.Brother';
export const CREDIT_APPLICANT_RELATION_FRIEND =
    'CreditApp.Applicant.Relationship.Friend';
export const CREDIT_APPLICANT_RELATION_GRANDFATHER =
    'CreditApp.Applicant.Relationship.Grandfather';
export const CREDIT_APPLICANT_RELATION_GIRLFRIEND =
    'CreditApp.Applicant.Relationship.Girlfriend';
export const CREDIT_APPLICANT_RELATION_GRANDMOTHER =
    'CreditApp.Applicant.Relationship.Grandmother';
export const CREDIT_APPLICANT_RELATION_OWNER =
    'CreditApp.Applicant.Relationship.Owner';
export const CREDIT_APPLICANT_RELATION_PRESIDENT =
    'CreditApp.Applicant.Relationship.President';
export const CREDIT_APPLICANT_RELATION_SISTER =
    'CreditApp.Applicant.Relationship.Sister';
export const CREDIT_APPLICANT_RELATION_TREASURER =
    'CreditApp.Applicant.Relationship.Treasurer';
export const CREDIT_APPLICANT_RELATION_UNCLE =
    'CreditApp.Applicant.Relationship.Uncle';
export const CREDIT_APPLICANT_RELATION_VICE_PRESIDENT =
    'CreditApp.Applicant.Relationship.VicePresident';
export const CREDIT_APPLICANT_RELATION_PARENT =
    'CreditApp.Applicant.Relationship.Parent';
export const CREDIT_APPLICANT_RELATION_SPOUSE =
    'CreditApp.Applicant.Relationship.Spouse';
export const CREDIT_APPLICANT_RELATION_OTHER =
    'CreditApp.Applicant.Relationship.Other';
export const CREDIT_APP_TITLE = 'CreditApp.Title';
export const CREDIT_APP_UPDATE_TITLE = 'CreditApp.UpdateTitle';
export const CREDIT_APP_SELECT_OPTION = 'CreditApp.SelectOption';
export const CREDIT_APP_TYPE_LABEL = 'CreditApp.ApplicationType.Label';
export const CREDIT_APP_TYPE_INDIVIDUAL =
    'CreditApp.ApplicationType.Individual';
export const CREDIT_APP_TYPE_JOINT = 'CreditApp.ApplicationType.Joint';
export const CREDIT_APP_TYPE_COAPP = 'CreditApp.ApplicationType.CoApplication';
export const CREDIT_APP_TYPE_BUSINESS = 'CreditApp.ApplicationType.Business';
export const CREDIT_APP_TYPE_BUSINESSCOAPP =
    'CreditApp.ApplicationType.BusinessCoApplicant';
export const CREDIT_APP_TYPE_BUSINESSGUARANTOR =
    'CreditApp.ApplicationType.BusinessPersonalGuarantor';
export const CREDIT_APP_TOOLTIP = 'CreditApp.Tooltip';
export const CREDIT_APP_OTHER_INFORMATION_TITLE_LABEL =
    'CreditApp.OtherInformation.Label.Title';
export const CREDIT_APP_OTHER_INFORMATION_PRINT_FIRST_STEP_HEADER =
    'CreditApp.OtherInformation.Print.FirstStep.Header';
export const CREDIT_APP_OTHER_INFORMATION_PRINT_FIRST_STEP_DESCRIPTION =
    'CreditApp.OtherInformation.Print.FirstStep.Description';
export const CREDIT_APP_OTHER_INFORMATION_PRINT_NEXT_STEP_HEADER =
    'CreditApp.OtherInformation.Print.NextStep.Header';
export const CREDIT_APP_OTHER_INFORMATION_PRINT_NEXT_STEP_DESCRIPTION =
    'CreditApp.OtherInformation.Print.NextStep.Description';
export const CREDIT_APP_OTHER_INFORMATION_PRINT_FINAL_STEP_HEADER =
    'CreditApp.OtherInformation.Print.FinalStep.Header';
export const CREDIT_APP_OTHER_INFORMATION_PRINT_FINAL_STEP_DESCRIPTION =
    'CreditApp.OtherInformation.Print.FinalStep.Description';
export const CREDIT_APP_OTHER_INFORMATION_PRINT_FINAL_STEP_ACK_STATEMENT =
    'CreditApp.OtherInformation.Print.FinalStep.AckStatement';
export const CREDIT_APP_OTHER_INFORMATION_PRINT_FINAL_STEP_SUB_HEADER =
    'CreditApp.OtherInformation.Print.FinalStep.SubHeader';
export const CREDIT_APP_PREVIOUS_ADDRESS_TITLE =
    'CreditApp.Applicant.PreviousAddress.Title';
export const CREDIT_APP_PREVIOUS_ADDRESS_NOTE =
    'CreditApp.Applicant.PreviousAddress.Note';
export const CREDIT_APP_REFERENCE_TITLE =
    'CreditApp.Applicant.References.Title';
export const CREDIT_APP_REFERENCE_ADD = 'CreditApp.Applicant.References.Add';
export const CREDIT_APP_REFERENCE_REMOVE =
    'CreditApp.Applicant.References.Remove';
export const CREDIT_APP_REFERENCE_PHONE =
    'CreditApp.Applicant.References.Phone';
export const CREDIT_APP_REFERENCE_LABEL =
    'CreditApp.Applicant.References.Relationship.Label';
export const CREDIT_APP_REFERENCE_FRIEND =
    'CreditApp.Applicant.References.Relationship.Friend';
export const CREDIT_APP_REFERENCE_RELATIVE =
    'CreditApp.Applicant.References.Relationship.Relative';
export const CREDIT_APP_REFERENCE_LANDLORD =
    'CreditApp.Applicant.References.Relationship.Landlord';
export const CREDIT_APP_REFERENCE_OTHER =
    'CreditApp.Applicant.References.Relationship.Other';

export const CREDIT_APP_AMOUNT_MINIMUN_ERROR = 'CreditApp.Amount.Minimum.Error';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_TITLE =
    'CreditApp.OtherInformation.Acknowledgement.Title';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_PRIMARY_APPLICANT =
    'CreditApp.OtherInformation.Acknowledgement.Primary';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_JOINT_APPLICANT =
    'CreditApp.OtherInformation.Acknowledgement.Joint';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_CO_APPLICANT =
    'CreditApp.OtherInformation.Acknowledgement.CoApp';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_BUSINESS_APPLICANT =
    'CreditApp.OtherInformation.Acknowledgement.Business';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_PERSONAL_GUARANTOR =
    'CreditApp.OtherInformation.Acknowledgement.PersonalGuarantor';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_INSTRUCTION =
    'CreditApp.OtherInformation.Acknowledgement.Instruction';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_PIPEDA_STATEMENT =
    'CreditApp.OtherInformation.Acknowledgement.Pipeda.Statement';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_PIPEDA_VW_CLIENT =
    'CreditApp.OtherInformation.Acknowledgement.Pipeda.Client.Vw';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_PIPEDA_AUDI_CLIENT =
    'CreditApp.OtherInformation.Acknowledgement.Pipeda.Client.Audi';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_PIPEDA_AUDI =
    'CreditApp.OtherInformation.Acknowledgement.Pipeda.Audi';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_PIPEDA_VW =
    'CreditApp.OtherInformation.Acknowledgement.Pipeda.Vw';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_CONTACT_MESSAGE =
    'CreditApp.OtherInformation.Acknowledgement.ContactMsg';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_CONTACT_AUDI =
    'CreditApp.OtherInformation.Acknowledgement.ContactMsgAudi';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_CONTACT_VW =
    'CreditApp.OtherInformation.Acknowledgement.ContactMsgVw';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_QUEBEC_ASSESSMENT =
    'CreditApp.OtherInformation.Acknowledgement.QuebecAssessment';
export const CREDIT_APP_OTHER_INFORMATION_ACKNOWLEDGEMENT_QUEBEC_CONTRACT =
    'CreditApp.OtherInformation.Acknowledgement.QuebecContract';
export const CREDIT_APP_OTHER_INFORMATION_NOTES_INFO =
    'CreditApp.OtherInformation.Notes.Info';
export const CREDIT_APP_OTHER_INFORMATION_NOTES_LABEL =
    'CreditApp.OtherInformation.Notes.Label';
export const CREDIT_APP_OTHER_INFORMATION_NOTES_TOOLTIP =
    'CreditApp.OtherInformation.Notes.Tooltip';
export const CREDIT_APP_OTHER_INFORMATION_FOOTER_FIRST =
    'CreditApp.OtherInformation.Footer.First';
export const CREDIT_APP_OTHER_INFORMATION_FOOTER_LINK =
    'CreditApp.OtherInformation.Footer.Link';
export const CREDIT_APP_OTHER_INFORMATION_FOOTER_PRIVACY_LINK =
    'CreditApp.OtherInformation.Footer.PrivacyLink';
export const CREDIT_APP_OTHER_INFORMATION_FOOTER_AND =
    'CreditApp.OtherInformation.Footer.And';
export const CREDIT_APP_OTHER_INFORMATION_FOOTER_LAST =
    'CreditApp.OtherInformation.Footer.Last';
export const CREDIT_APP_BUTTON_CONTINUE = 'CreditApp.Button.Label';
export const OCCUPATION_TITLE_LABEL = 'CreditApp.Occupation.Title';
export const CREDIT_APP_PROMPT_TITLE = 'CreditApp.Prompt.Title';
export const CREDIT_APP_PROMPT_DESCRIPTION = 'CreditApp.Prompt.Description';
export const CREDIT_APP_PROMPT_CANCEL_BTN_TXT = 'CreditApp.Prompt.Cancel';
export const CREDIT_APP_PROMPT_PROCEED_BTN_TXT = 'CreditApp.Prompt.Proceed';
export const OCCUPATION_TITLE_LABEL_TYPE =
    'CreditApp.Occupation.EmploymentType';
export const OCCUPATION_INCOME_LABEL = 'CreditApp.Occupation.Income';
export const OCCUPATION_TYPE_INCOME_LABEL = 'CreditApp.Occupation.TypeofIncome';
export const OCCUPATION_EMPLOYED_LABEL = 'CreditApp.Occupation.Employed';
export const OCCUPATION_OTHER_INCOME_LABEL = 'CreditApp.Occupation.OtherIncome';
export const OCCUPATION_FREQUENCY_LABEL = 'CreditApp.Occupation.Frequency';
export const OCCUPATION_FREQUENCY_INCOME_MONTHLY_LABEL =
    'CreditApp.Occupation.IncomeFrequency.Monthly';
export const OCCUPATION_FREQUENCY_INCOME_HOURLY_LABEL =
    'CreditApp.Occupation.IncomeFrequency.Hourly';
export const OCCUPATION_FREQUENCY_INCOME_WEEKLY_LABEL =
    'CreditApp.Occupation.IncomeFrequency.Weekly';
export const OCCUPATION_FREQUENCY_INCOME_EVERY_2_LABEL =
    'CreditApp.Occupation.IncomeFrequency.Every2Weeks';
export const OCCUPATION_FREQUENCY_INCOME_BI_MONTH_LABEL =
    'CreditApp.Occupation.IncomeFrequency.BiMonthly';
export const OCCUPATION_FREQUENCY_INCOME_ANNUAL_LABEL =
    'CreditApp.Occupation.IncomeFrequency.Annual';
export const OCCUPATION_GROSS_LABEL = 'CreditApp.Occupation.GrossAmount';
export const OCCUPATION_ADD_INCOME_LABEL = 'CreditApp.Occupation.AddIncome';
export const OCCUPATION_ADD_OTHER_INCOME_LABEL =
    'CreditApp.Occupation.AddOtherIncome';
export const OCCUPATION_DELETE_INCOME_LABEL =
    'CreditApp.Occupation.DeleteIncome';
export const OCCUPATION_DELETE_OTHER_INCOME_LABEL =
    'CreditApp.Occupation.DeleteOtherIncome';
export const OCCUPATION_EMPLOY_INFO_LABEL =
    'CreditApp.Occupation.EmploymentInformation';
export const OCCUPATION_SELF_EMPLOY_LABEL = 'CreditApp.Occupation.SelfEmployed';
export const OCCUPATION_RETIRED_LABEL = 'CreditApp.Occupation.Retired';
export const OCCUPATION_PROVINCES_AB_LABEL =
    'CreditApp.Occupation.Provinces.AB';
export const OCCUPATION_PROVINCES_BC_LABEL =
    'CreditApp.Occupation.Provinces.BC';
export const OCCUPATION_PROVINCES_MB_LABEL =
    'CreditApp.Occupation.Provinces.MB';
export const OCCUPATION_PROVINCES_NB_LABEL =
    'CreditApp.Occupation.Provinces.NB';
export const OCCUPATION_PROVINCES_NL_LABEL =
    'CreditApp.Occupation.Provinces.NL';
export const OCCUPATION_PROVINCES_NS_LABEL =
    'CreditApp.Occupation.Provinces.NS';
export const OCCUPATION_PROVINCES_NT_LABEL =
    'CreditApp.Occupation.Provinces.NT';
export const OCCUPATION_PROVINCES_NU_LABEL =
    'CreditApp.Occupation.Provinces.NU';
export const OCCUPATION_PROVINCES_ON_LABEL =
    'CreditApp.Occupation.Provinces.ON';
export const OCCUPATION_PROVINCES_PE_LABEL =
    'CreditApp.Occupation.Provinces.PE';
export const OCCUPATION_PROVINCES_QC_LABEL =
    'CreditApp.Occupation.Provinces.QC';
export const OCCUPATION_PROVINCES_SK_LABEL =
    'CreditApp.Occupation.Provinces.SK';
export const OCCUPATION_PROVINCES_YT_LABEL =
    'CreditApp.Occupation.Provinces.YT';
export const OCCUPATION_CURRENT_COMPANY_LABEL =
    'CreditApp.Occupation.currentCompany';
export const OCCUPATION_CURRENT_EMPLOYER_LABEL =
    'CreditApp.Occupation.currentEmployer';
export const OCCUPATION_PREVIOUS_EMPLOYER_LABEL =
    'CreditApp.Occupation.previousEmployer';
export const OCCUPATION_PREVIOUS_EMPLOYER_DESC1 =
    'CreditApp.Occupation.previousEmployerDesc1';
export const OCCUPATION_PREVIOUS_EMPLOYER_DESC2 =
    'CreditApp.Occupation.previousEmployerDesc2';
export const OCCUPATION_COMPANY_LABEL = 'CreditApp.Occupation.company';
export const OCCUPATION_EMPLOYER_LABEL = 'CreditApp.Occupation.employer';
export const OCCUPATION_ADDRESS_LABEL = 'CreditApp.Occupation.address';
export const OCCUPATION_ADDRESS_ERR_LABEL = 'CreditApp.Occupation.addressErr1';
export const OCCUPATION_CITY_LABEL = 'CreditApp.Occupation.city';
export const OCCUPATION_CITY_ERR_LABEL = 'CreditApp.Occupation.cityErrMsg';
export const OCCUPATION_ZIP_LABEL = 'CreditApp.Occupation.zip';
export const OCCUPATION_ZIP_ERR_LABEL = 'CreditApp.Occupation.zipError';
export const OCCUPATION_POSTAL_LABEL = 'CreditApp.Occupation.postal';
export const OCCUPATION_POSTAL_ERR_LABEL = 'CreditApp.Occupation.postalError';
export const OCCUPATION_OCCUPATION_LABEL = 'CreditApp.Occupation.occupation';
export const OCCUPATION_OCCUPATION_ERR_LABEL =
    'CreditApp.Occupation.occupationError';
export const OCCUPATION_YEARS_LABEL = 'CreditApp.Occupation.years';
export const OCCUPATION_YEARS_ERR_LABEL = 'CreditApp.Occupation.yearsError';
export const OCCUPATION_MONTHS_LABEL = 'CreditApp.Occupation.months';
export const OCCUPATION_MONTHS_ERR_LABEL = 'CreditApp.Occupation.monthsError';
export const OCCUPATION_PRIMARY_APP_LABEL =
    'CreditApp.Occupation.primaryApplicant';
export const OCCUPATION_CO_APP_LABEL = 'CreditApp.Occupation.coApplicant';
export const OCCUPATION_JOINT_APP_LABEL = 'CreditApp.Occupation.jointApplicant';
export const OCCUPATION_VALID_AMOUNT_ERR_LABEL =
    'CreditApp.Occupation.validAmount';
export const OCCUPATION_VALID_REQUIRED_ERR_LABEL =
    'CreditApp.Occupation.missingInvalid';
export const OCCUPATION_COUNTRY_LABEL = 'CreditApp.Occupation.country';
export const OCCUPATION_STATE_LABEL = 'CreditApp.Occupation.state';
export const OCCUPATION_PROVINCE_LABEL = 'CreditApp.Occupation.province';
export const OCCUPATION_OCCUPATION_INCOME_LABEL =
    'CreditApp.Occupation.occupation&Income';

export const CREDIT_APP_BUSINESS_TITLE = 'CreditApp.Business.Title';
export const CREDIT_APP_BUSINESS_APPLICANT_TITLE =
    'CreditApp.Business.Applicant.Title';
export const CREDIT_APP_BUSINESS_APPLICANT_OPTION_CORPORATION =
    'CreditApp.Business.Applicant.Options.Corporation';
export const CREDIT_APP_BUSINESS_APPLICANT_OPTION_PARTNERSHIP =
    'CreditApp.Business.Applicant.Options.Partnership';
export const CREDIT_APP_BUSINESS_APPLICANT_OPTION_PROPRIERTORSHIP =
    'CreditApp.Business.Applicant.Options.Proprietorship';
export const CREDIT_APP_BUSINESS_APPLICANT_OPTION_GOVERMENT =
    'CreditApp.Business.Applicant.Options.Goverment';
export const CREDIT_APP_BUSINESS_APPLICANT_OPTION_MUNICIPALITY =
    'CreditApp.Business.Applicant.Options.Municipality';
export const CREDIT_APP_BUSINESS_APPLICANT_OPTION_NONPROFIT =
    'CreditApp.Business.Applicant.Options.Nonprofit';
export const CREDIT_APP_BUSINESS_APPLICANT_OPTION_OTHER =
    'CreditApp.Business.Applicant.Options.Other';
export const CREDIT_APP_BUSINESS_APPLICANT_OPTION_LLC =
    'CreditApp.Business.Applicant.Options.LLC';
export const CREDIT_APP_BUSINESS_APPLICANT_OPTION_SCORPORATION =
    'CreditApp.Business.Applicant.Options.SCorporation';
export const CREDIT_APP_BUSINESS_APPLICANT_OPTION_SOLEPROP =
    'CreditApp.Business.Applicant.Options.SoleProprietorship';
export const CREDIT_APP_BUSINESS_APPLICANT_INFO =
    'CreditApp.Business.Applicant.Info';
export const CREDIT_APP_BUSINESS_APPLICANT_INFO_USA =
    'CreditApp.Business.Applicant.InfoUSA';
export const CREDIT_APP_BUSINESS_APPLICANT_NAME =
    'CreditApp.Business.Applicant.Name';
export const CREDIT_APP_BUSINESS_APPLICANT_TYPE =
    'CreditApp.Business.Applicant.Type';
export const CREDIT_APP_BUSINESS_APPLICANT_INCORPORATION =
    'CreditApp.Business.Applicant.Incorporation';
export const CREDIT_APP_BUSINESS_APPLICANT_FEDERAL =
    'CreditApp.Business.Applicant.Federal';
export const CREDIT_APP_BUSINESS_APPLICANT_PROVINCE =
    'CreditApp.Business.Applicant.Province';
export const CREDIT_APP_BUSINESS_APPLICANT_CHOOSEPROVINCE =
    'CreditApp.Business.Applicant.ChooseProvince';
export const CREDIT_APP_BUSINESS_APPLICANT_YEARS =
    'CreditApp.Business.Applicant.Years';
export const CREDIT_APP_BUSINESS_APPLICANT_MONTHS =
    'CreditApp.Business.Applicant.Months';
export const CREDIT_APP_BUSINESS_APPLICANT_TELEPHONE =
    'CreditApp.Business.Applicant.Telephone';
export const CREDIT_APP_BUSINESS_BUSINESS_TITLE =
    'CreditApp.Business.Business.Title';
export const CREDIT_APP_BUSINESS_BUSINESS_ADDRESS1 =
    'CreditApp.Business.Business.Addess1';
export const CREDIT_APP_BUSINESS_BUSINESS_ADDRESS2 =
    'CreditApp.Business.Business.Addess2';
export const CREDIT_APP_BUSINESS_BUSINESS_CITY =
    'CreditApp.Business.Business.City';
export const CREDIT_APP_BUSINESS_BUSINESS_PROVINCE =
    'CreditApp.Business.Business.Province';
export const CREDIT_APP_BUSINESS_BUSINESS_POSTALCODE =
    'CreditApp.Business.Business.PostalCode';
export const CREDIT_APP_BUSINESS_OWNERS_TITLE =
    'CreditApp.Business.Owners.Title';
export const CREDIT_APP_BUSINESS_OWNERS_NAME = 'CreditApp.Business.Owners.Name';
export const CREDIT_APP_BUSINESS_OWNERS_MI = 'CreditApp.Business.Owners.MI';
export const CREDIT_APP_BUSINESS_OWNERS_LASTNAME =
    'CreditApp.Business.Owners.LastName';
export const CREDIT_APP_BUSINESS_OWNERS_TITLELABEL =
    'CreditApp.Business.Owners.TitleLabel';
export const CREDIT_APP_BUSINESS_OWNERS_CHOOSETITLE =
    'CreditApp.Business.Owners.Choose';
export const CREDIT_APP_BUSINESS_OWNERS_OWNERSHIP =
    'CreditApp.Business.Owners.Ownership';
export const CREDIT_APP_BUSINESS_RESPONSIBLE_TITLE =
    'CreditApp.Business.Responsible.Title';
export const CREDIT_APP_BUSINESS_RESPONSIBLE_NAME =
    'CreditApp.Business.Responsible.Name';
export const CREDIT_APP_BUSINESS_RESPONSIBLE_MI =
    'CreditApp.Business.Responsible.MI';
export const CREDIT_APP_BUSINESS_RESPONSIBLE_LASTNAME =
    'CreditApp.Business.Responsible.LastName';
export const CREDIT_APP_BUSINESS_RESPONSIBLE_TELEPHONE =
    'CreditApp.Business.Responsible.Telephone';
export const CREDIT_APP_BUSINESS_DRIVER_TITLE =
    'CreditApp.Business.Driver.Title';
export const CREDIT_APP_BUSINESS_DRIVER_INFO = 'CreditApp.Business.Driver.Info';
export const CREDIT_APP_BUSINESS_DRIVER_RELATIONSHIP =
    'CreditApp.Business.Driver.Relationship';
export const CREDIT_APP_BUSINESS_DRIVER_OPTION_OWNER =
    'CreditApp.Business.Driver.Option.Owner';
export const CREDIT_APP_BUSINESS_DRIVER_OPTION_PRESIDENT =
    'CreditApp.Business.Driver.Option.President';
export const CREDIT_APP_BUSINESS_DRIVER_OPTION_VICEPRESIDENT =
    'CreditApp.Business.Driver.Option.VicePresident';
export const CREDIT_APP_BUSINESS_DRIVER_OPTION_TREASURER =
    'CreditApp.Business.Driver.Option.Treasurer';
export const CREDIT_APP_BUSINESS_DRIVER_OPTION_OTHER =
    'CreditApp.Business.Driver.Option.Other';
export const CREDIT_APP_BUSINESS_DRIVER_NAME = 'CreditApp.Business.Driver.Name';
export const CREDIT_APP_BUSINESS_DRIVER_MI = 'CreditApp.Business.Driver.MI';
export const CREDIT_APP_BUSINESS_DRIVER_LASTNAME =
    'CreditApp.Business.Driver.LastName';
export const CREDIT_APP_BUSINESS_DRIVER_CITY = 'CreditApp.Business.Driver.City';
export const CREDIT_APP_BUSINESS_DRIVER_PROVINCE =
    'CreditApp.Business.Driver.Province';
export const CREDIT_APP_BUSINESS_DRIVER_POSTALCODE =
    'CreditApp.Business.Driver.PostalCode';
export const CREDIT_APP_BUSINESS_DRIVER_YEARS =
    'CreditApp.Business.Driver.Years';
export const CREDIT_APP_BUSINESS_DRIVER_MONTHS =
    'CreditApp.Business.Driver.Months';
export const CREDIT_APP_BUSINESS_DRIVER_LICENSE =
    'CreditApp.Business.Driver.License';
export const CREDIT_APP_BUSINESS_DRIVER_DATE = 'CreditApp.Business.Driver.Date';
export const CREDIT_APP_BUSINESS_DRIVER_BIRTHDATE =
    'CreditApp.Business.Driver.BirthDate';
export const CREDIT_APP_BUSINESS_DRIVER_TELEPHONE =
    'CreditApp.Business.Driver.Telephone';
export const CREDIT_APP_BUSINESS_DRIVER_ADDRESS1 =
    'CreditApp.Business.Driver.Addess1';
export const CREDIT_APP_BUSINESS_DRIVER_ADDRESS2 =
    'CreditApp.Business.Driver.Addess2';
export const INVALID_FIELD = 'CreditApp.Business.InvalidField';
export const REQUIRED_FIELD = 'CreditApp.Business.RequiredField';
export const CREDIT_APP_BUSINESS_REFERENCE_TITLE =
    'CreditApp.Business.References.Title';
export const CREDIT_APP_BUSINESS_REFERENCE_PREVIOUSCAR =
    'CreditApp.Business.References.PreviousCar';
export const CREDIT_APP_BUSINESS_REFERENCE_ADDREFERENCE =
    'CreditApp.Business.References.AddReference';
export const CREDIT_APP_BUSINESS_REFERENCE_REMOVEREFERENCE =
    'CreditApp.Business.References.DeleteReference';
export const CREDIT_APP_BUSINESS_REFERENCE_BANKNAME =
    'CreditApp.Business.References.BankName';
export const CREDIT_APP_BUSINESS_REFERENCE_TYPE =
    'CreditApp.Business.References.Type';
export const CREDIT_APP_BUSINESS_REFERENCE_TYPES_CHECKING =
    'CreditApp.Business.References.Types.Checking';
export const CREDIT_APP_BUSINESS_REFERENCE_TYPES_SAVINGS =
    'CreditApp.Business.References.Types.Savings';
export const CREDIT_APP_BUSINESS_REFERENCE_TYPES_LINE =
    'CreditApp.Business.References.Types.Line';
export const CREDIT_APP_BUSINESS_REFERENCE_BRANCH =
    'CreditApp.Business.References.Branch';
export const CREDIT_APP_BUSINESS_REFERENCE_ADDRESS1 =
    'CreditApp.Business.References.Address1';
export const CREDIT_APP_BUSINESS_REFERENCE_ADDRESS2 =
    'CreditApp.Business.References.Address2';
export const CREDIT_APP_BUSINESS_REFERENCE_CITY =
    'CreditApp.Business.References.City';
export const CREDIT_APP_BUSINESS_REFERENCE_PROVINCE =
    'CreditApp.Business.References.Province';
export const CREDIT_APP_BUSINESS_REFERENCE_POSTAL =
    'CreditApp.Business.References.PostalCode';
export const CREDIT_APP_BUSINESS_REFERENCE_TELEPHONE =
    'CreditApp.Business.References.Telephone';
export const CREDIT_APP_BUSINESS_REFERENCE_ACCOUNTNO =
    'CreditApp.Business.References.AccountNo';
export const CREDIT_APP_BUSINESS_REQUIRED_OR_INVALID =
    'CreditApp.RequiredOrInvalid';
export const CREDIT_APP_BUSINESS_CO_APP_INFO =
    'CreditApp.Business.CoBusinessInfo';
export const CREDIT_APP_BUSINESS_GUARANTOR_APP_INFO =
    'CreditApp.Business.GuarantorBusinessInfo';
export const CREDIT_APP_BUSINESS_CO_APP_INCOME =
    'CreditApp.Business.CoBusinessIncome';
export const CREDIT_APP_BUSINESS_GUARANTOR_APP_INCOME =
    'CreditApp.Business.GuarantorBusinessIncome';
export const CREDIT_APP_BUSINESS_RENT_MORTAGE =
    'CreditApp.Business.RentMortage';

//Password Reset
export const PASSWORD_RESET_TITLE = 'PasswordReset.Label.Title';
export const PASSWORD_RESET_DESCRIPTION = 'PasswordReset.Description';
export const PASSWORD_RESET_LABEL_PASSWORD = 'PasswordReset.Label.Password';
export const PASSWORD_RESET_LABEL_CONFIRM_PASSWORD =
    'PasswordReset.Label.ConfirmPassword';
export const PASSWORD_RESET_LABEL_INVALID_PASSWORD =
    'PasswordReset.Label.Invalid';
export const PASSWORD_RESET_LABEL_WRONG_PASSWORD = 'PasswordReset.Label.Wrong';
export const PASSWORD_RESET_LABEL_RULE_PASSWORD = 'PasswordReset.Label.Rules';
export const PASSWORD_RESET_LABEL_BACK_LOGIN = 'PasswordReset.Label.Back';
export const PASSWORD_RESET_SUCCESS_INFO = 'PasswordReset.Success.Info';
export const PASSWORD_RESET_TOKEN_ERROR = 'PasswordReset.Token.Error';
export const PASSWORD_RESET_TOKEN_ERROR_LINK = 'PasswordReset.Token.Link';
export const PASSWORD_RESET_TOKEN_ERROR2 = 'PasswordReset.Token.Error2';

//Forgot Password
export const FORGOT_PASSWORD_TITLE = 'ForgotPassword.Label.Title';
export const FORGOT_PASSWORD_DESCRIPTION = 'ForgotPassword.Description';
export const FORGOT_PASSWORD_LABEL_EMAIL = 'ForgotPassword.Label.Email';
export const FORGOT_PASSWORD_SUCCESS_INFO = 'ForgotPassword.Success.Info';
export const FORGOT_PASSWORD_SUCCESS_INFO2 = 'ForgotPassword.Success.Info2';
export const FORGOT_PASSWORD_MFA_TITLE = 'ForgotPassword.Mfa.Title';
export const FORGOT_PASSWORD_MFA_DESCRIPTION = 'ForgotPassword.Mfa.Description';
export const FORGOT_PASSWORD_MFA_ENTER = 'ForgotPassword.Mfa.Enter';

//Credit Search
export const CREDIT_SEARCH_PLACEHOLDER_INPUT =
    'CreditSearch.Placeholder.Search';
export const CREDIT_SEARCH_TOOLTIP_INPUT = 'CreditSearch.Tooltip.Search';
export const CREDIT_SEARCH_TOOLTIP_INPUT_CA = 'CreditSearch.Tooltip.SearchCa';
export const CREDIT_SEARCH_TABLE_OPTION_MONTHS =
    'CreditSearch.Table.Option.Months';
export const CREDIT_SEARCH_TABLE_OPTION_DATE_PREFIX =
    'CreditSearch.Table.Option.Date.Prefix';
export const CREDIT_SEARCH_TABLE_OPTION_DATE_PLACEHOLDER =
    'CreditSearch.Table.Option.Date.Placeholder';
export const CREDIT_SEARCH_TABLE_OPTION_STATUS_ALL =
    'CreditSearch.Table.Option.Status.All';
export const CREDIT_SEARCH_TABLE_HEADER_SUBMITTED_DATE =
    'CreditSearch.Table.Header.SubmittedDate';
export const CREDIT_SEARCH_TABLE_HEADER_SUBMITTED =
    'CreditSearch.Table.Header.Submitted';
export const CREDIT_SEARCH_TABLE_HEADER_COLLATERAL =
    'CreditSearch.Table.Header.Collateral';
export const CREDIT_SEARCH_TABLE_HEADER_STATUS =
    'CreditSearch.Table.Header.Status';
export const CREDIT_SEARCH_TABLE_HEADER_APPLICATION_NUMBER =
    'CreditSearch.Table.Header.ApplicationNumber';
export const CREDIT_SEARCH_TABLE_HEADER_APPLICANT_NAME =
    'CreditSearch.Table.Header.ApplicantName';
export const CREDIT_SEARCH_HEADER_LABEL = 'CreditSearch.Header.Label';

//Credit Details
export const CREDIT_DETAILS_HEADER_LABEL = 'CreditDetails.Header.Label';
export const CREDIT_DETAILS_APPLICANT_TITLE =
    'CreditDetails.ApplicantInformation.Title';
export const CREDIT_DETAILS_APPLICANT_TITLE_JOINT =
    'CreditDetails.ApplicantInformation.Joint';
export const CREDIT_DETAILS_APPLICANT_TITLE_COAPP =
    'CreditDetails.ApplicantInformation.CoApp';
export const CREDIT_DETAILS_APPLICANT_TITLE_GUARANTOR =
    'CreditDetails.ApplicantInformation.Guarantor';
export const CREDIT_DETAILS_APPLICANT_LABEL_NAME =
    'CreditDetails.ApplicantInformation.Label.Name';
export const CREDIT_DETAILS_APPLICANT_LABEL_ADDRESS =
    'CreditDetails.ApplicantInformation.Label.Address';
export const CREDIT_DETAILS_APPLICANT_LABEL_HOME =
    'CreditDetails.ApplicantInformation.Label.Home';
export const CREDIT_DETAILS_APPLICANT_LABEL_MOBILE =
    'CreditDetails.ApplicantInformation.Label.Mobile';
export const CREDIT_DETAILS_APPLICANT_LABEL_SSN =
    'CreditDetails.ApplicantInformation.Label.SSN';
export const CREDIT_DETAILS_APPLICANT_LABEL_APPLICATION_NUMBER =
    'CreditDetails.ApplicantInformation.Label.ApplicationNumber';
export const CREDIT_DETAILS_COLLATERAL_LABEL_TYPE =
    'CreditDetails.Collateral.Label.Type';
export const CREDIT_DETAILS_COLLATERAL_LABEL_VEHICLE_TYPE =
    'CreditDetails.Collateral.Label.VehicleType';
export const CREDIT_DETAILS_COLLATERAL_LABEL_AMOUNT_FINANCED =
    'CreditDetails.Collateral.Label.AmountFinanced';
export const CREDIT_DETAILS_COLLATERAL_LABEL_ADJUSTED_CAP_COST =
    'CreditDetails.Collateral.Label.AdjustedCapCost';
export const CREDIT_DETAILS_COLLATERAL_LABEL_TERM =
    'CreditDetails.Collateral.Label.Term';
export const CREDIT_DETAILS_COLLATERAL_LABEL_TIER =
    'CreditDetails.Collateral.Label.Tier';
export const CREDIT_DETAILS_COLLATERAL_LABEL_ESTIMATED =
    'CreditDetails.Collateral.Label.Estimated';
export const CREDIT_DETAILS_COLLATERAL_LABEL_LTV =
    'CreditDetails.Collateral.Label.LTV';
export const CREDIT_DETAILS_COLLATERAL_LABEL_VALUE =
    'CreditDetails.Collateral.Label.Value';
export const CREDIT_DETAILS_DETAIL_TITLE = 'CreditDetails.Details.Title';
export const CREDIT_DETAILS_DETAIL_LABEL_DEALER =
    'CreditDetails.Details.Label.Dealer';
export const CREDIT_DETAILS_DETAIL_LABEL_PHONE =
    'CreditDetails.Details.Label.Phone';
export const CREDIT_DETAILS_DETAIL_LABEL_CREDIT_AUTHORIZER =
    'CreditDetails.Details.Label.CreditAuthorizer';
export const CREDIT_DETAILS_DETAIL_LABEL_CURRENT_STATUS =
    'CreditDetails.Details.Label.CurrentStatus';
export const CREDIT_DETAILS_DETAIL_LABEL_COMMENTS =
    'CreditDetails.Details.Label.Comments';
export const CREDIT_DETAILS_DETAIL_LABEL_DECISIONED =
    'CreditDetails.Details.Label.Decisioned';
export const CREDIT_DETAILS_DETAIL_LABEL_SUBMITTED =
    'CreditSearch.Table.Header.SubmittedDate';
export const CREDIT_DETAILS_DETAIL_LABEL_SUBMITTED_BY =
    'CreditSearch.Table.Header.Submitted';
export const CREDIT_DETAILS_DETAIL_LTV_DISCLAIMER =
    'CreditDetails.Details.LTV.Disclaimer';
export const PORTFOLIO_MANAGER_HEADER_LABEL =
    'PortfolioManagerDetails.Header.Label';
export const PORTFOLIO_MANAGER_ERROR = 'PortfolioManagerDetails.ErrorMessage';
export const PORTFOLIO_MANAGER_CUSTOMER_INFORMATION_HEADER_LABEL =
    'PortfolioManagerDetails.CustomerInformation.Header.Label';
export const PORTFOLIO_MANAGER_CUSTOMER_INFORMATION_BUYER =
    'PortfolioManagerDetails.CustomerInformation.Buyer';
export const PORTFOLIO_MANAGER_CUSTOMER_INFORMATION_CO_BUYER =
    'PortfolioManagerDetails.CustomerInformation.CoBuyer';
export const PORTFOLIO_MANAGER_CUSTOMER_INFORMATION_CURRENT_MATURITY_DATE =
    'PortfolioManagerDetails.CustomerInformation.CurrentMaturityDate';
export const PORTFOLIO_MANAGER_CUSTOMER_INFORMATION_ORIGINAL_MATURITY_DATE =
    'PortfolioManagerDetails.CustomerInformation.OriginalMaturityDate';
export const PORTFOLIO_MANAGER_CUSTOMER_INFORMATION_PRIVACY =
    'PortfolioManagerDetails.CustomerInformation.Privacy';
export const PORTFOLIO_MANAGER_CUSTOMER_INFORMATION_VIN =
    'PortfolioManagerDetails.CustomerInformation.VIN';

export const PORTFOLIO_MANAGER_CONTACT_INFORMATION_HEADER_LABEL =
    'PortfolioManagerDetails.CustomerContactInformation.Header.Label';
export const PORTFOLIO_MANAGER_CONTACT_INFORMATION_GARAGING_ADDRESS =
    'PortfolioManagerDetails.CustomerContactInformation.GaragingAddress';
export const PORTFOLIO_MANAGER_CONTACT_INFORMATION_HOME_PHONE =
    'PortfolioManagerDetails.CustomerContactInformation.HomePhone';
export const PORTFOLIO_MANAGER_CONTACT_INFORMATION_WORK_PHONE =
    'PortfolioManagerDetails.CustomerContactInformation.WorkPhone';
export const PORTFOLIO_MANAGER_CONTACT_INFORMATION_CELL_PHONE =
    'PortfolioManagerDetails.CustomerContactInformation.CellPhone';
export const PORTFOLIO_MANAGER_CONTACT_INFORMATION_EMAIL =
    'PortfolioManagerDetails.CustomerContactInformation.Email';
export const PORTFOLIO_MANAGER_CONTACT_INFORMATION_CO_BUYER_ADDRESS =
    'PortfolioManagerDetails.CustomerContactInformation.CoBuyerAddress';
export const PORTFOLIO_MANAGER_CONTACT_INFORMATION_CO_BUYER_PHONE =
    'PortfolioManagerDetails.CustomerContactInformation.CoBuyerPhone';
export const PORTFOLIO_MANAGER_CONTACT_INFORMATION_CO_BUYER_WORK_PHONE =
    'PortfolioManagerDetails.CustomerContactInformation.CoBuyerWorkPhone';
export const PORTFOLIO_MANAGER_CONTACT_INFORMATION_CO_BUYER_CELL_PHONE =
    'PortfolioManagerDetails.CustomerContactInformation.CoBuyerCellPhone';
export const PORTFOLIO_MANAGER_CONTACT_INFORMATION_CO_BUYER_EMAIL =
    'PortfolioManagerDetails.CustomerContactInformation.CoBuyerEmail';

export const PORTFOLIO_MANAGER_VEHICLE_INFORMATION_HEADER_LABEL =
    'PortfolioManagerDetails.VehicleInformation.Header.Label';
export const PORTFOLIO_MANAGER_VEHICLE_INFORMATION_YEAR =
    'PortfolioManagerDetails.VehicleInformation.Year';
export const PORTFOLIO_MANAGER_VEHICLE_INFORMATION_MAKE =
    'PortfolioManagerDetails.VehicleInformation.Make';
export const PORTFOLIO_MANAGER_VEHICLE_INFORMATION_MODEL =
    'PortfolioManagerDetails.VehicleInformation.Model';
export const PORTFOLIO_MANAGER_VEHICLE_INFORMATION_MODEL_CODE =
    'PortfolioManagerDetails.VehicleInformation.ModelCode';
export const PORTFOLIO_MANAGER_VEHICLE_INFORMATION_TERM =
    'PortfolioManagerDetails.VehicleInformation.Term';
export const PORTFOLIO_MANAGER_VEHICLE_INFORMATION_COLOR =
    'PortfolioManagerDetails.VehicleInformation.Color';
export const PORTFOLIO_MANAGER_VEHICLE_INFORMATION_DESCRIPTION =
    'PortfolioManagerDetails.VehicleInformation.VehicleDescription';
export const PORTFOLIO_MANAGER_VEHICLE_INFORMATION_OPTIONS =
    'PortfolioManagerDetails.VehicleInformation.Options';

export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_HEADER_LABEL =
    'PortfolioManagerDetails.AccountInformation.Header.Label';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_ACCOUNT_NUMBER =
    'PortfolioManagerDetails.AccountInformation.AccountNumber';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_CONTRACT_DATE =
    'PortfolioManagerDetails.AccountInformation.ContractDate';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_BRAND_SP_CODE =
    'PortfolioManagerDetails.AccountInformation.brandSpCode';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_ACCOUNT_TYPE =
    'PortfolioManagerDetails.AccountInformation.AccountType';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_TOTAL_ACCOUNTS =
    'PortfolioManagerDetails.AccountInformation.TotalAccounts';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_BOUGHT_AS =
    'PortfolioManagerDetails.AccountInformation.BoughtAs';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_ORIGINAL_ODOMETER =
    'PortfolioManagerDetails.AccountInformation.OriginalOdometer';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_ALLOWABLE_MILEAGE =
    'PortfolioManagerDetails.AccountInformation.AllowableMileage';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_CURRENT_RESIDUAL =
    'PortfolioManagerDetails.AccountInformation.CurrentResidual';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_SECURITY_DEPOSIT =
    'PortfolioManagerDetails.AccountInformation.SecurityDeposit';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_MONEY_FACTOR =
    'PortfolioManagerDetails.AccountInformation.MoneyFactor';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_BASE_PAYMENT =
    'PortfolioManagerDetails.AccountInformation.BasePayment';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_PAYMENT_FREQUENCY =
    'PortfolioManagerDetails.AccountInformation.PaymentFrequency';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_APR =
    'PortfolioManagerDetails.AccountInformation.APR';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_DOWN_PAYMENT =
    'PortfolioManagerDetails.AccountInformation.DownPayment';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_OUTSTANDING_BALANCE =
    'PortfolioManagerDetails.AccountInformation.OutstandingBalance';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_PURCHASE_OPTION_FEE =
    'PortfolioManagerDetails.AccountInformation.PurchaseOptionFee';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_PROGRAM_ELIGIBILITY =
    'PortfolioManagerDetails.AccountInformation.ProgramEligibility';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_ESTIMATED_BB_VALUE =
    'PortfolioManagerDetails.AccountInformation.EstimatedBBValue';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_ESTIMATED_EQUITY =
    'PortfolioManagerDetails.AccountInformation.EstimatedEquity';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_VEHICLE_TURN_IN_DATE =
    'PortfolioManagerDetails.AccountInformation.VehicleTurnInDate';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_PAYOFF_DATE =
    'PortfolioManagerDetails.AccountInformation.PayoffDate';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_LEASE_TRANSFER =
    'PortfolioManagerDetails.AccountInformation.LeaseTransfer';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_QUOTE_TYPE =
    'PortfolioManagerDetails.AccountInformation.QuoteType';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_LAST_QUOTE_GENERATED =
    'PortfolioManagerDetails.AccountInformation.LastQuoteGenerated';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_AUDI_CARE =
    'PortfolioManagerDetails.AccountInformation.AudiCare';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_TURN_IN_FEE =
    'PortfolioManagerDetails.AccountInformation.TurnInFee';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_PAYMENT_FREQUENCY_VALUES_MONTHLY =
    'PortfolioManagerDetails.AccountInformation.PaymentFrequencyValues.Monthly';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_PAYMENT_FREQUENCY_VALUES_BIWEEKLY =
    'PortfolioManagerDetails.AccountInformation.PaymentFrequencyValues.BiWeekly';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_PAYMENT_FREQUENCY_VALUES_SEMI_MONTHLY =
    'PortfolioManagerDetails.AccountInformation.PaymentFrequencyValues.SemiMonthly';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_PAYMENT_FREQUENCY_VALUES_SINGLE_PAY =
    'PortfolioManagerDetails.AccountInformation.PaymentFrequencyValues.SinglePay';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_PAYMENT_FREQUENCY_VALUES_WEEKLY =
    'PortfolioManagerDetails.AccountInformation.PaymentFrequencyValues.Weekly';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_QUOTE_TYPE_VALUES_CUSTOMER =
    'PortfolioManagerDetails.AccountInformation.QuoteTypeValues.Customer';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_QUOTE_TYPE_VALUES_DEALER =
    'PortfolioManagerDetails.AccountInformation.QuoteTypeValues.Dealer';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_BOUGHT_AS_TYPE_NEW =
    'PortfolioManagerDetails.AccountInformation.BoughtAsType.New';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_BOUGHT_AS_TYPE_PREOWNED =
    'PortfolioManagerDetails.AccountInformation.BoughtAsType.PreOwned';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_BOUGHT_AS_TYPE_CPO =
    'PortfolioManagerDetails.AccountInformation.BoughtAsType.CPO';
export const PORTFOLIO_MANAGER_ACCOUNT_INFORMATION_BOUGHT_AS_TYPE_DEMO =
    'PortfolioManagerDetails.AccountInformation.BoughtAsType.Demo';
export const CREDIT_DETAILS_BUTTONS_EDIT = 'CreditDetails.Details.Buttons.Edit';
export const CREDIT_DETAILS_TOOLTIP = 'CreditDetails.Details.Tooltip';
export const PAYMENT_MAKE_TITLE = 'Payments.Make.Title';
export const PAYMENT_MAKE_DESCRIPTION = 'Payments.Make.Description';
export const PAYMENT_MAKE_TITLEFORM = 'Payments.Make.TitleForm';
export const PAYMENT_MAKE_PAYMENTBTN = 'Payments.Make.PaymentBtn';
export const PAYMENT_MAKE_PAYOFFBTN = 'Payments.Make.PayOffBtn';
export const PAYMENT_MAKE_ACCOUNTLABEL = 'Payments.Make.AccountLabel';
export const PAYMENT_MAKE_ACCOUNTERROR = 'Payments.Make.AccountError';
export const PAYMENT_MAKE_ACCOUNTTIP = 'Payments.Make.AccountTip';
export const PAYMENT_MAKE_VINLABEL = 'Payments.Make.VinLabel';
export const PAYMENT_MAKE_VINERROR = 'Payments.Make.VinError';
export const PAYMENT_MAKE_VINTIP = 'Payments.Make.VinTip';
export const PAYMENT_MAKE_SUBMIT = 'Payments.Make.SubmitBtn';
export const PAYMENT_INFORMATION_TITLE = 'Payments.Information.TitleForm';
export const PAYMENT_EDIT_INFORMATION_TITLE =
    'Payments.Information.EditTitleForm';
export const PAYMENT_INFORMATION_AMOUNTLABEL =
    'Payments.Information.AmountLabel';
export const PAYMENT_INFORMATION_AMOUNTERR = 'Payments.Information.AmountErr';
export const PAYMENT_INFORMATION_AMOUNTERRPAYOFF =
    'Payments.Information.AmountErrPayOff';
export const PAYMENT_INFORMATION_REASONLABEL =
    'Payments.Information.ReasonLabel';
export const PAYMENT_INFORMATION_REASONERR = 'Payments.Information.ReasonErr';
export const PAYMENT_INFORMATION_TYPELABEL = 'Payments.Information.TypeLabel';
export const PAYMENT_INFORMATION_CHECKINGLABEL =
    'Payments.Information.Checkinglabel';
export const PAYMENT_INFORMATION_SAVINGSLABEL =
    'Payments.Information.Savingslabel';
export const PAYMENT_INFORMATION_DEALERREFLABEL =
    'Payments.Information.DealerRefLabel';
export const PAYMENT_INFORMATION_DEALERREFERR =
    'Payments.Information.DealerRefError';
export const PAYMENT_INFORMATION_COMMENTLABEL =
    'Payments.Information.CommentLabel';
export const PAYMENT_INFORMATION_COMMENT = 'Payments.Information.Comment';
export const PAYMENT_INFORMATION_COMMENTIP = 'Payments.Information.CommentTip';
export const PAYMENT_INFORMATION_COMMENT1ERR =
    'Payments.Information.Comment1Error';
export const PAYMENT_INFORMATION_COMMENT2ERR =
    'Payments.Information.Comment2Error';
export const PAYMENT_INFORMATION_CANCELBTN = 'Payments.Information.CancelBtn';
export const PAYMENT_INFORMATION_SUBMITBTN = 'Payments.Information.SubmitBtn';
export const PAYMENT_INFORMATION_SUBMITAPPBTN =
    'Payments.Information.SubmitAppBtn';
export const PAYMENT_INFORMATION_CONFIRMBTN = 'Payments.Information.ConfirmBtn';
export const PAYMENT_INFORMATION_ACCOUNTINFOLABEL =
    'Payments.Information.AccountInformationLabel';
export const PAYMENT_INFORMATION_ACCOUNTINFOTIP =
    'Payments.Information.AccountInformationTip';
export const PAYMENT_INFORMATION_ACCOUNTNUMBERLABEL =
    'Payments.Information.AccNumberLabel';
export const PAYMENT_INFORMATION_ACCOUNTTYPELABEL =
    'Payments.Information.AccTypeLabel';
export const PAYMENT_INFORMATION_VEHICLEIDLABEL =
    'Payments.Information.VehicleIdLabel';
export const PAYMENT_INFORMATION_VEHICLEDESCLABEL =
    'Payments.Information.VehicleDescriptionLabel';
export const PAYMENT_INFORMATION_VEHICLEMODEL =
    'Payments.Information.VehicleModelLabel';
export const PAYMENT_INFORMATION_VEHICLEMAKEL =
    'Payments.Information.VehicleMakeLabel';
export const PAYMENT_INFORMATION_CUSTOMERNAMELABEL =
    'Payments.Information.CustomerNameLabel';
export const PAYMENT_INFORMATION_ADDRESSLABEL =
    'Payments.Information.AddressLabel';
export const PAYMENT_INFORMATION_LOCATIONLABEL =
    'Payments.Information.LocationLabel';
export const PAYMENT_INFORMATION_PROVINCELABEL =
    'Payments.Information.ProvinceLabel';
export const PAYMENT_INFORMATION_DEALERNUMLABEL =
    'Payments.Information.DealerNumberLabel';
export const PAYMENT_INFORMATION_OPTIONS_DEFAULT =
    'Payments.Information.SelectOptions.Default';
export const PAYMENT_INFORMATION_OPTIONS_CURT =
    'Payments.Information.SelectOptions.Curtailment';
export const PAYMENT_INFORMATION_OPTIONS_REGULAR =
    'Payments.Information.SelectOptions.Regular';
export const PAYMENT_INFORMATION_OPTIONS_LEASE =
    'Payments.Information.SelectOptions.Lease';
export const PAYMENT_INFORMATION_OPTIONS_FLAT =
    'Payments.Information.SelectOptions.Flat';
export const PAYMENT_INFORMATION_OPTIONS_INVOICE =
    'Payments.Information.SelectOptions.Invoice';
export const PAYMENT_INFORMATION_OPTIONS_OTHER =
    'Payments.Information.SelectOptions.Other';
export const PAYMENT_INFORMATION_OPTIONS_CHARGEBACK =
    'Payments.Information.SelectOptions.ChargeBack';
export const PAYMENT_INFORMATION_TRANSACTION_ID =
    'Payments.Information.TransactionId';
export const PAYMENT_INFORMATION_WITHDRAWAL_DATE =
    'Payments.Information.Withdrwal';
export const PAYMENT_INFORMATION_RETURN_LABEL =
    'Payments.Information.ReturnLabel';
export const PAYMENT_INFORMATION_EDIT_LABEL = 'Payments.Information.EditLabel';
export const PAYMENT_INFORMATION_PAIDFROM = 'Payments.Information.PaidFrom';
export const PAYMENT_INFORMATION_CHECKING = 'Payments.Information.Checking';
export const PAYMENT_INFORMATION_SAVINGS = 'Payments.Information.Savings';
export const PAYMENT_INFORMATION_LINE = 'Payments.Information.Line';
export const PAYMENT_INFORMATION_AMOUNT_ERR_LIMIT =
    'Payments.Information.AmountErrLimit';
export const PAYMENT_INFORMATION_NOTE = 'Payments.Information.Note';
export const PAYMENT_INFORMATION_DETAILS_PEDINGTITLE =
    'Payments.Details.PendingTitle';
export const PAYMENT_INFORMATION_DETAILS_ACCOUNTINFO =
    'Payments.Details.AccountInfo';
export const PAYMENT_INFORMATION_DETAILS_PAYMENTINFO =
    'Payments.Details.PaymentInfo';
export const PAYMENT_INFORMATION_DETAILS_BUTTONS_CLOSE =
    'Payments.Details.Buttons.Close';
export const PAYMENT_INFORMATION_DETAILS_BUTTONS_EDIT =
    'Payments.Details.Buttons.Edit';
export const PAYMENT_INFORMATION_DETAILS_BUTTONS_DELETE =
    'Payments.Details.Buttons.Delete';
export const PAYMENT_INFORMATION_DETAILS_BUTTONS_APPROVE =
    'Payments.Details.Buttons.Approve';
export const PAYMENT_INFORMATION_DETAILS_APPROVE_CONFIRM_TITLE =
    'Payments.Details.ApproveConfirmation.Title';
export const PAYMENT_INFORMATION_DETAILS_APPROVE_CONFIRM_CANCEL =
    'Payments.Details.ApproveConfirmation.Cancel';
export const PAYMENT_INFORMATION_DETAILS_APPROVE_CONFIRM_PROCEED =
    'Payments.Details.ApproveConfirmation.Proceed';
export const PAYMENT_INFORMATION_TABLE_TITLE = 'Payments.Table.Title';
export const PAYMENT_INFORMATION_TABLE_TAB_TITLE = 'Payments.Table.Title';
export const PAYMENT_INFORMATION_TABLE_TAB_TITLE1 = 'Payments.Table.Title1';
export const PAYMENT_INFORMATION_TABLE_DISCLAIMER = 'Payments.Table.Disclaimer';
export const PAYMENT_INFORMATION_TABLE_DISCLAIMER_CONTENT =
    'Payments.Table.DisclaimerContent';
export const PAYMENT_INFORMATION_TABLE_HEADERS_TRANSACTION =
    'Payments.Table.Headers.Transaction';
export const PAYMENT_INFORMATION_TABLE_HEADERS_TYPE =
    'Payments.Table.Headers.Type';
export const PAYMENT_INFORMATION_TABLE_HEADERS_ACCOUNT =
    'Payments.Table.Headers.Account';
export const PAYMENT_INFORMATION_TABLE_HEADERS_VIN =
    'Payments.Table.Headers.VIN';
export const PAYMENT_INFORMATION_TABLE_HEADERS_AMOUNT =
    'Payments.Table.Headers.Amount';
export const PAYMENT_INFORMATION_TABLE_HEADERS_METHOD =
    'Payments.Table.Headers.Method';
export const PAYMENT_INFORMATION_TABLE_HEADERS_STATUS =
    'Payments.Table.Headers.Status';
export const PAYMENT_INFORMATION_TABLE_HEADERS_DATE =
    'Payments.Table.Headers.Date';
export const PAYMENT_INFORMATION_TAB_PAYMENT = 'Payments.Tab.Payment';
export const PAYMENT_INFORMATION_TAB_PAYOFF = 'Payments.Tab.Payoff';
export const PAYMENT_INFORMATION_DELETE_CONFIRMATION_TITLE =
    'Payments.Details.DeleteTitle';
export const PAYMENT_INFORMATION_CREATE_SUCCESS_MESSAGGE =
    'Payments.Information.SuccessMessage';
export const PAYMENT_INFORMATION_PAYOFF_SUCCESS_MESSAGGE =
    'Payments.Information.PayoffSuccessMessage';
export const PAYMENT_INFORMATION_CREATE_ERROR_MESSAGE =
    'Payments.Information.ErrorMessage';
export const PAYMENT_INFORMATION_DELETE_SUCCESS_MESSAGGE =
    'Payments.Details.DeleteSuccessTittle';
export const PAYMENT_INFORMATION_DELETE_ERROR_MESSAGE =
    'Payments.Details.DeleteErrorTitle';
export const PAYMENT_INFORMATION_APPROVE_CONFIRMATION_TITLE =
    'Payments.Details.ApproveTitle';
export const PAYMENT_INFORMATION_APPROVE_SUCCESS_MESSAGGE =
    'Payments.Details.ApproveSuccessTittle';
export const PAYMENT_INFORMATION_APPROVE_ERROR_MESSAGE =
    'Payments.Details.ApproveErrorTitle';
export const PAYMENT_HISTORY_TITLE = 'Payments.History.Title';
export const PAYMENT_HISTORY_SEARCH_PANDP = 'Payments.History.Search.PandP';
export const PAYMENT_HISTORY_SEARCH_PAYMENT = 'Payments.History.Search.Payment';
export const PAYMENT_HISTORY_SEARCH_PAYOFF = 'Payments.History.Search.PayOff';
export const PAYMENT_HISTORY_SEARCH_MONTH = 'Payments.History.Search.LastMonth';
export const PAYMENT_HISTORY_SEARCH_2MONTH =
    'Payments.History.Search.Last2Months';
export const PAYMENT_HISTORY_SEARCH_3MONTH =
    'Payments.History.Search.Last3Months';
export const PAYMENT_HISTORY_SEARCH_ALL = 'Payments.History.Search.AllStatus';
export const PAYMENT_HISTORY_SEARCH_DELETED = 'Payments.History.Search.Deleted';
export const PAYMENT_HISTORY_SEARCH_EXPIRED = 'Payments.History.Search.Expired';
export const PAYMENT_HISTORY_SEARCH_SUBMITTED =
    'Payments.History.Search.Submitted';
export const PAYMENT_HISTORY_SEARCH_RESET =
    'Payments.History.Search.ResetFilter';
export const PAYMENT_HISTORY_TABLE_DATE = 'Payments.History.Table.Date';
export const PAYMENT_HISTORY_TABLE_TYPE =
    'Payments.History.Table.AccountType.Title';
export const PAYMENT_HISTORY_TABLE_TYPE_LEASE =
    'Payments.History.Table.AccountType.OperatingLease';
export const PAYMENT_HISTORY_TABLE_TYPE_LOAN =
    'Payments.History.Table.AccountType.RetailLoan';
export const PAYMENT_HISTORY_TABLE_TYPE_BALLOON =
    'Payments.History.Table.AccountType.RetailBalloon';
export const PAYMENT_HISTORY_TABLE_STATUS =
    'Payments.History.Table.PaymentStatus.Title';
export const PAYMENT_HISTORY_TABLE_STATUS_0 =
    'Payments.History.Table.PaymentStatus.0';
export const PAYMENT_HISTORY_TABLE_STATUS_1 =
    'Payments.History.Table.PaymentStatus.1';
export const PAYMENT_HISTORY_TABLE_STATUS_2 =
    'Payments.History.Table.PaymentStatus.2';
export const PAYMENT_HISTORY_TABLE_STATUS_3 =
    'Payments.History.Table.PaymentStatus.3';
export const PAYMENT_HISTORY_TABLE_STATUS_4 =
    'Payments.History.Table.PaymentStatus.4';
export const PAYMENT_HISTORY_TABLE_ACCOUNT = 'Payments.History.Table.Account';
export const PAYMENT_HISTORY_TABLE_AMOUNT = 'Payments.History.Table.Amount';
export const PAYMENT_HISTORY_TABLE_REASON =
    'Payments.History.Table.PaymentReason.Title';
export const PAYMENT_HISTORY_TABLE_REASON_REGULAR =
    'Payments.History.Table.PaymentReason.RegularPayment';
export const PAYMENT_HISTORY_TABLE_REASON_CURTAILMENT =
    'Payments.History.Table.PaymentReason.Curtailment';
export const PAYMENT_HISTORY_TABLE_REASON_CANCEL =
    'Payments.History.Table.PaymentReason.FlatCancel';
export const PAYMENT_HISTORY_TABLE_REASON_OTHER =
    'Payments.History.Table.PaymentReason.Other';
export const PAYMENT_HISTORY_TABLE_REASON_CHARGEBACK =
    'Payments.History.Table.PaymentReason.ChargeBack';
export const PAYMENT_HISTORY_TABLE_REASON_END =
    'Payments.History.Table.PaymentReason.EndOfTermInvoice';
export const PAYMENT_HISTORY_TABLE_REASON_LEASE =
    'Payments.History.Table.PaymentReason.LeaseTransferFee';
export const PAYMENT_HISTORY_TABLE_COMMENT = 'Payments.History.Table.Comment';
export const PAYMENT_HISTORY_TABLE_USER = 'Payments.History.Table.UserName';

export const PAYMENT_QUOTE_TITLE = 'Payments.PayoffQuotes.Quotes.Title';
export const PAYMENT_QUOTE_ADVISORY = 'Payments.PayoffQuotes.Quotes.Advisory';
export const PAYMENT_QUOTE_LINK = 'Payments.PayoffQuotes.Quotes.Link';
export const PAYMENT_QUOTE_LINK2 = 'Payments.PayoffQuotes.Quotes.Link2';
export const PAYMENT_QUOTE_ALERT = 'Payments.PayoffQuotes.Quotes.Alert';
export const PAYMENT_QUOTE_ERROR = 'Payments.PayoffQuotes.Quotes.Error';
export const PAYMENT_QUOTE_SEARCH = 'Payments.PayoffQuotes.Quotes.Search';

export const PAYOFF_QUOTE_DETAIL_PRIVATE =
    'Payments.PayoffQuotes.Detail.Private';
export const PAYOFF_QUOTE_DETAIL_TITLE = 'Payments.PayoffQuotes.Detail.Title';
export const PAYOFF_QUOTE_DETAIL_WARNING_MESSAGE =
    'Payments.PayoffQuotes.Detail.Warning';
export const PAYOFF_QUOTE_DETAIL_BUTTON = 'Payments.PayoffQuotes.Detail.Button';
export const PAYOFF_QUOTE_INFO_TITLE_LEASE =
    'Payments.PayoffQuotes.Detail.QuoteInfo.LeaseTitle';
export const PAYOFF_QUOTE_INFO_TITLE_RETAIL =
    'Payments.PayoffQuotes.Detail.QuoteInfo.RetailTitle';
export const PAYOFF_QUOTE_INFO_AMOUNT =
    'Payments.PayoffQuotes.Detail.QuoteInfo.Amount';
export const PAYOFF_QUOTE_INFO_THROUGH =
    'Payments.PayoffQuotes.Detail.QuoteInfo.ThroughDate';
export const PAYOFF_QUOTE_INFO_DATE =
    'Payments.PayoffQuotes.Detail.QuoteInfo.Date';
export const PAYOFF_QUOTE_INFO_ADVISORY =
    'Payments.PayoffQuotes.Detail.QuoteInfo.Advisory';
export const PAYOFF_QUOTE_INFO_NOTE_US_VW =
    'Payments.PayoffQuotes.Detail.QuoteInfo.Note.US.VW';
export const PAYOFF_QUOTE_INFO_NOTE_US_AU =
    'Payments.PayoffQuotes.Detail.QuoteInfo.Note.US.AU';
export const PAYOFF_QUOTE_INFO_NOTE_CA_VW =
    'Payments.PayoffQuotes.Detail.QuoteInfo.Note.CA.VW';
export const PAYOFF_QUOTE_INFO_NOTE_CA_AU =
    'Payments.PayoffQuotes.Detail.QuoteInfo.Note.CA.AU';
export const PAYOFF_QUOTE_INFO_NOTE_ATTENTION =
    'Payments.PayoffQuotes.Detail.QuoteInfo.Note.Attetion';
export const PAYOFF_QUOTE_INFO_NOTE_ADVICE =
    'Payments.PayoffQuotes.Detail.QuoteInfo.Note.Advice';
export const PAYOFF_QUOTE_INFO_NOTE_PAYMENT =
    'Payments.PayoffQuotes.Detail.QuoteInfo.Note.Payment';
export const PAYOFF_QUOTE_INFO_NOTE_LABEL =
    'Payments.PayoffQuotes.Detail.QuoteInfo.Note.Label';

export const PAYOFF_QUOTE_DETAILS_TITLE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Title';
export const PAYOFF_QUOTE_DETAILS_RETAIL_BALANCE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Balance';
export const PAYOFF_QUOTE_DETAILS_RETAIL_INTEREST =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Interest';
export const PAYOFF_QUOTE_DETAILS_RETAIL_FEE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Title';
export const PAYOFF_QUOTE_DETAILS_RETAIL_BAILIFF =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Bailiff';
export const PAYOFF_QUOTE_DETAILS_RETAIL_IMPOUND =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Impound';

export const PAYOFF_QUOTE_DETAILS_RETAIL_LEGAL =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Legal';
export const PAYOFF_QUOTE_DETAILS_RETAIL_MISCELLANEOUS =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Miscellaneous';
export const PAYOFF_QUOTE_DETAILS_RETAIL_REPOSESSION =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Repossession';
export const PAYOFF_QUOTE_DETAILS_RETAIL_STORAAGE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Storage';
export const PAYOFF_QUOTE_DETAILS_RETAIL_EXTENSION =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Extension';
export const PAYOFF_QUOTE_DETAILS_RETAIL_TRANSFER =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Transfer';
export const PAYOFF_QUOTE_DETAILS_RETAIL_VIOLATION =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Violation';
export const PAYOFF_QUOTE_DETAILS_RETAIL_ADMIN =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Administrative';
export const PAYOFF_QUOTE_DETAILS_RETAIL_TRACER =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Tracer';
export const PAYOFF_QUOTE_DETAILS_RETAIL_OWNERSHIP =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Ownership';
export const PAYOFF_QUOTE_DETAILS_RETAIL_LIEN =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Lien';
export const PAYOFF_QUOTE_DETAILS_RETAIL_REGISTRATION =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Registration';
export const PAYOFF_QUOTE_DETAILS_RETAIL_PURCHASE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Purchase';
export const PAYOFF_QUOTE_DETAILS_RETAIL_MATURITY =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Retail.Fees.Maturity';
export const PAYOFF_QUOTE_DETAILS_LEASE_VALUE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Value';
export const PAYOFF_QUOTE_DETAILS_LEASE_PAYOUT =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Payout';
export const PAYOFF_QUOTE_DETAILS_LEASE_DUE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Due';
export const PAYOFF_QUOTE_DETAILS_LEASE_TAXDUE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.TaxOnDue';
export const PAYOFF_QUOTE_DETAILS_LEASE_PAYMENT =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Payments';
export const PAYOFF_QUOTE_DETAILS_LEASE_TAXPAYMENT =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.TaxOnPayments';
export const PAYOFF_QUOTE_DETAILS_LEASE_CHARGES =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Charges';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_TITLE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.Title';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_TAX =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.Tax';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_CHARGE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.Charge';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FEX =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FEX';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FTE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FTE';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FTK =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FTK';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FDM =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FDM';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FCB =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FCB';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FLG =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FLG';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FRS =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FRS';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FRI =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FRI';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FCS =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FCS';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FCO =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FCO';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FRR =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FRR';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FRM =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FRM';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FMS =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FMS';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FTT =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FTT';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FEU =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FEU';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FEP =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FEX';
export const PAYOFF_QUOTE_DETAILS_LEASE_FEE_FNF =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Lease.Fees.FNF';
export const PAYOFF_QUOTE_DETAILS_PAYMENT_TITLE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Payment.Title';
export const PAYOFF_QUOTE_DETAILS_PAYMENT_CHECKS_DIGITAL =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Payment.Checks.Digital';
export const PAYOFF_QUOTE_DETAILS_PAYMENT_CHECKS_BRASS =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Payment.Checks.Brass';
export const PAYOFF_QUOTE_DETAILS_PAYMENT_NOTE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Payment.Note';
export const PAYOFF_QUOTE_DETAILS_PAYMENT_NOTE_LABEL =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Payment.NoteLabel';
export const PAYOFF_QUOTE_DETAILS_PAYMENT_NOTE_AUTHORIZATION =
    'Payments.PayoffQuotes.Detail.QuoteDetails.Payment.AuthorizationNote';
export const PAYOFF_QUOTE_DETAILS_NOTE_TITLE =
    'Payments.PayoffQuotes.Detail.QuoteNote.Title';
export const PAYOFF_QUOTE_DETAILS_NOTE_US =
    'Payments.PayoffQuotes.Detail.QuoteNote.US';
export const PAYOFF_QUOTE_DETAILS_NOTE_CA =
    'Payments.PayoffQuotes.Detail.QuoteNote.CA';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_TITLE =
    'Payments.PayoffQuotes.Detail.Account.Title';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_TERM =
    'Payments.PayoffQuotes.Detail.Account.Term';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_FINALDATE =
    'Payments.PayoffQuotes.Detail.Account.FinalDate';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_SCHPAYMENT =
    'Payments.PayoffQuotes.Detail.Account.ScheduledPayment';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_REMPAYMENT =
    'Payments.PayoffQuotes.Detail.Account.RemainingPayments';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_NEXTDATE =
    'Payments.PayoffQuotes.Detail.Account.NextDate';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_LASTPAYMENT =
    'Payments.PayoffQuotes.Detail.Account.LastPayment';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_LASTDATE =
    'Payments.PayoffQuotes.Detail.Account.LastDate';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_BALANCE =
    'Payments.PayoffQuotes.Detail.Account.Balance';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_MATURITYDATE =
    'Payments.PayoffQuotes.Detail.Account.MaturityDate';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_AMTBEFORETAX =
    'Payments.PayoffQuotes.Detail.Account.AmtBeforeTax';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_GSTHST =
    'Payments.PayoffQuotes.Detail.Account.GstHst';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_OTHERAMOUNT =
    'Payments.PayoffQuotes.Detail.Account.OtherAmount';
export const PAYMENTS_MAKE_LABEL =
    'Payments.PayoffQuotes.Detail.AccountInfo.Make';
export const PAYMENTS_MODEL_LABEL =
    'Payments.PayoffQuotes.Detail.AccountInfo.Model';
export const PAYOFF_QUOTE_INFORMATION_TITLE =
    'Payments.Payoff.QuoteInformation.Title';
export const PAYOFF_QUOTE_INFORMATION_AMOUNT_BEFORE_TAX =
    'Payments.Payoff.QuoteInformation.AmountBeforeTax';
export const PAYOFF_QUOTE_INFORMATION_GOOD_THROUGH_DATE =
    'Payments.Payoff.QuoteInformation.GoodThroughDate';
export const PAYOFF_QUOTE_INFORMATION_TAX_AMOUNT =
    'Payments.Payoff.QuoteInformation.TaxAmount';
export const PAYOFF_QUOTE_INFORMATION_QUOTE_DATE =
    'Payments.Payoff.QuoteInformation.QuoteDate';
export const PAYOFF_QUOTE_INFORMATION_TOTAL_QUOTE_AMOUNT =
    'Payments.Payoff.QuoteInformation.TotalQuoteAmount';
export const PAYOFF_QUOTE_INFORMATION_QUOTE_AMOUNT =
    'Payments.Payoff.QuoteInformation.QuoteAmount';
export const PAYOFF_PAYMENT_INFORMATION_ODOMETER_READING =
    'Payments.Payoff.PaymentInformation.OdometerReading';
export const PAYOFF_PAYMENT_INFORMATION_SECURITY_DEPOSIT =
    'Payments.Payoff.PaymentInformation.SecurityDeposit';
export const PAYOFF_PAYMENT_INFORMATION_PURCHASE_TYPE_LABEL =
    'Payments.Payoff.PaymentInformation.PurchaseTypeLabel';
export const PAYOFF_PAYMENT_INFORMATION_PURCHASE_TYPE_DEALER =
    'Payments.Payoff.PaymentInformation.PurchaseTypeDealerInventory';
export const PAYOFF_PAYMENT_INFORMATION_PURCHASE_TYPE_CUSTOMER =
    'Payments.Payoff.PaymentInformation.PurchaseTypeCustomerBuyback';
export const PAYOFF_PAYMENT_INFORMATION_ASSIGN_SECURITY_DEPOSIT_LABEL =
    'Payments.Payoff.PaymentInformation.AssignSecurityDepositLabel';
export const PAYOFF_PAYMENT_INFORMATION_ASSIGN_SECURITY_DEPOSIT_CUSTOMER =
    'Payments.Payoff.PaymentInformation.AssignSecurityDepositCustomer';
export const PAYOFF_PAYMENT_INFORMATION_ASSIGN_SECURITY_DEPOSIT_DEALER =
    'Payments.Payoff.PaymentInformation.AssignSecurityDepositDealer';
export const PAYOFF_PAYMENT_INFORMATION_ASSIGN_SECURITY_DEPOSIT_DEDUCT =
    'Payments.Payoff.PaymentInformation.AssignSecurityDepositDeduct';
export const PAYOFF_PAYMENT_INFORMATION_PAYMENT_TYPE_LABEL =
    'Payments.Payoff.PaymentInformation.PaymentTypeLabel';
export const PAYOFF_PAYMENT_INFORMATION_PAYMENT_TYPE_CHEQUE =
    'Payments.Payoff.PaymentInformation.PaymentTypeChequing';
export const PAYOFF_PAYMENT_INFORMATION_PAYMENT_TYPE_SAVINGS =
    'Payments.Payoff.PaymentInformation.PaymentTypeSavings';
export const PAYOFF_PAYMENT_INFORMATION_PAYMENT_TYPE_BRASS =
    'Payments.Payoff.PaymentInformation.PaymentTypeBrassHat';
export const PAYOFF_PAYMENT_INFORMATION_LOYALTY_VIN =
    'Payments.Payoff.PaymentInformation.LoyaltyVin';
export const PAYOFF_PAYMENT_INFORMATION_DISCLAIMER =
    'Payments.Payoff.PaymentInformation.Disclaimer';
export const PAYOFF_PAYMENT_INFORMATION_DISCLAIMER_TITLE =
    'Payments.Payoff.PaymentInformation.DisclaimerTitle';
export const PAYOFF_PAYMENT_INFORMATION_TOTAL =
    'Payments.Payoff.PaymentInformation.Total';
export const PAYOFF_PAYMENT_INFORMATION_LPA_LABEL =
    'Payments.Payoff.PaymentInformation.LPALabel';
export const PAYOFF_PAYMENT_INFORMATION_LPA_AUDI_TOOLTIP =
    'Payments.Payoff.PaymentInformation.LPATooltipAudi';
export const PAYOFF_PAYMENT_INFORMATION_LPA_VW_TOOLTIP =
    'Payments.Payoff.PaymentInformation.LPATooltipVW';
export const PAYOFF_PAYMENT_INFORMATION_ASSIGN_SECURITY_DEPOSIT_WARNING =
    'Payments.Payoff.PaymentInformation.AssignSecurityWarning';
export const PAYOFF_PAYMENT_INFORMATION_LOYALTY_VIN_ERROR =
    'Payments.Payoff.PaymentInformation.LoyaltyVinError';
export const PAYOFF_PAYMENT_INFORMATION_PURCHASE_TYPE_ERROR =
    'Payments.Payoff.PaymentInformation.PurchaseTypeError';
export const PAYOFF_PAYMENT_INFORMATION_LPA_ERROR =
    'Payments.Payoff.PaymentInformation.LPAError';
export const PAYOFF_PAYMENT_INFORMATION_ODOMETER_READING_ERROR =
    'Payments.Payoff.PaymentInformation.OdometerError';

export const PAYMENT_WARNING_MESSAGE_CLOSED_ACCOUNT =
    'Payments.WarningMessage.ClosedAccount';
export const PAYMENT_WARNING_MESSAGE_NOT_IN_PORTFOLIO =
    'Payments.WarningMessage.NotInPortfolio';
export const PAYMENT_WARNING_MESSAGE_REDIRECT_CA =
    'Payments.WarningMessage.RedirectCA';
export const PAYMENT_WARNING_MESSAGE_REDIRECT_US_VW =
    'Payments.WarningMessage.RedirectVWUS';

export const PAYOFF_QUOTE_DETAILS_US_TITLE =
    'Payments.PayoffQuotes.DetailUS.Title';
export const PAYOFF_QUOTE_DETAILS_US_NEW_SEARCH =
    'Payments.PayoffQuotes.DetailUS.NewSearch';
export const PAYOFF_QUOTE_DETAILS_US_ACCOUNT_INFO_TITLE =
    'Payments.PayoffQuotes.DetailUS.AccountInfo.Title';
export const PAYOFF_QUOTE_DETAILS_US_VIN_LABEL =
    'Payments.PayoffQuotes.DetailUS.VinLabel';
export const PAYOFF_QUOTE_DETAILS_US_ORIGINAL_CONTRACT_DATE =
    'Payments.PayoffQuotes.DetailUS.OriginalContractDate';
export const PAYOFF_QUOTE_DETAILS_US_PAYMENT_DETAILS_TITLE =
    'Payments.PayoffQuotes.DetailUS.PaymentDetails.Title';
export const PAYOFF_QUOTE_DETAILS_US_MONTHLY_PAYMENT_EXCLUDES_TAX =
    'Payments.PayoffQuotes.DetailUS.MonthlyPaymentExcludesTax';
export const PAYOFF_QUOTE_DETAILS_US_REMAINING_PAYMENTS =
    'Payments.PayoffQuotes.DetailUS.RemainingPayments';
export const PAYOFF_QUOTE_DETAILS_US_MONTHLY_PAYMENT_INCLUDES_TAX =
    'Payments.PayoffQuotes.DetailUS.MonthlyPaymentIncludesTax';
export const PAYOFF_QUOTE_DETAILS_US_LAST_PAYMENT_DATE =
    'Payments.PayoffQuotes.DetailUS.LastPaymentDate';
export const PAYOFF_QUOTE_DETAILS_US_TOTAL_REMAINING_PAYMENTS =
    'Payments.PayoffQuotes.DetailUS.TotalRemainingPayments';
export const PAYOFF_QUOTE_DETAILS_US_OTHER_INVOICED_CHARGES =
    'Payments.PayoffQuotes.DetailUS.OtherInvoicedCharges';
export const PAYOFF_QUOTE_DETAILS_US_OUTSTANDING_BALANCE =
    'Payments.PayoffQuotes.DetailUS.OutstandingBalance';
export const PAYOFF_QUOTE_DETAILS_US_TOTAL_OUTSTANDING_BALANCE =
    'Payments.PayoffQuotes.DetailUS.TotalOutstandingBalance';
export const PAYOFF_QUOTE_DETAILS_US_FOOTNOTE_PROJECTED =
    'Payments.PayoffQuotes.DetailUS.FootnoteProjected';
export const PAYOFF_QUOTE_DETAILS_US_FOOTNOTE_DISPOSITION =
    'Payments.PayoffQuotes.DetailUS.FootnoteDisposition';
export const PAYOFF_QUOTE_DETAILS_US_CANCEL_BUTTON =
    'Payments.PayoffQuotes.DetailUS.CancelButton';
export const PAYOFF_QUOTE_DETAILS_US_GET_PAYOFF_QUOTE_BUTTON =
    'Payments.PayoffQuotes.DetailUS.GetPayoffQuoteButton';
export const PAYOFF_QUOTE_DETAILS_US_OPERATING_LEASE =
    'Payments.PayoffQuotes.DetailUS.OperatingLease';
export const PAYOFF_QUOTE_DETAILS_US_SINGLE_PAY_LEASE =
    'Payments.PayoffQuotes.DetailUS.SinglePayLease';
export const PAYOFF_QUOTE_DETAILS_US_RETAIL_LOAN =
    'Payments.PayoffQuotes.DetailUS.RetailLoan';
export const PAYOFF_QUOTE_DETAILS_US_RETAIL_BALLOON =
    'Payments.PayoffQuotes.DetailUS.RetailBalloon';
export const PAYMENT_WARNING_MESSAGE_REDIRECT_US_AUDI =
    'Payments.WarningMessage.RedirectAudiUS';
export const PAYMENT_WARNING_MESSAGE_REDIRECT_US_DUCATI =
    'Payments.WarningMessage.RedirectDucatiUS';
export const PAYMENT_WARNING_MESSAGE_QUOTE_EXCEPTION_US =
    'Payments.WarningMessage.QuoteExceptionUS';
export const PAYMENT_WARNING_MESSAGE_QUOTE_EXCEPTION_CA =
    'Payments.WarningMessage.QuoteExceptionCA';
export const PAYMENT_WARNING_MESSAGE_QUOTE_CANNOT_BE_RETURNED_US =
    'Payments.WarningMessage.QuoteCannotBeReturnedUS';
export const PAYMENT_WARNING_MESSAGE_QUOTE_CANNOT_BE_RETURNED_CA =
    'Payments.WarningMessage.QuoteCannotBeReturnedCA';
export const PAYMENT_WARNING_MESSAGE_UNKNOWN_EXCEPTION_VW_CA =
    'Payments.WarningMessage.UnknownExceptionVWCA';
export const PAYMENT_WARNING_MESSAGE_UNKNOWN_EXCEPTION_AUDI_CA =
    'Payments.WarningMessage.UnknownExceptionAudiCA';
export const PAYMENT_WARNING_MESSAGE_UNKNOWN_EXCEPTION_DUCATI_CA =
    'Payments.WarningMessage.UnknownExceptionDucatiCA';
export const PAYMENT_WARNING_MESSAGE_UNKNOWN_EXCEPTION_VW_US =
    'Payments.WarningMessage.UnknownExceptionVWUS';
export const PAYMENT_WARNING_MESSAGE_UNKNOWN_EXCEPTION_AUDI_US =
    'Payments.WarningMessage.UnknownExceptionAudiUS';
export const PAYMENT_WARNING_MESSAGE_UNKNOWN_EXCEPTION_DUCATI_US =
    'Payments.WarningMessage.UnknownExceptionDucatiUS';
export const PAYMENT_WARNING_MESSAGE_PAYOFF_PAYMENT_EXCLUDED_VW =
    'Payments.WarningMessage.PayoffPaymentExcludedVW';
export const PAYMENT_WARNING_MESSAGE_PAYOFF_PAYMENT_EXCLUDED_AUDI =
    'Payments.WarningMessage.PayoffPaymentExcludedAudi';
export const PAYMENT_WARMNING_MESSAGE_CHARGED_OFF_VW =
    'Payments.WarningMessage.ChargedOffUSVW';
export const PAYMENT_WARMNING_MESSAGE_CHARGED_OFF_AUDI =
    'Payments.WarningMessage.ChargedOffUSAudi';
export const PAYMENT_WARMNING_MESSAGE_CHARGED_OFF_DUCATI =
    'Payments.WarningMessage.ChargedOffUSDucati';
export const PAYMENT_WARNING_MESSAGE_CONTACT_REP_VW =
    'Payments.WarningMessage.ContactRepVW';
export const PAYMENT_WARNING_MESSAGE_CONTACT_REP_AUDI =
    'Payments.WarningMessage.ContactRepAudi';
export const PAYMENT_WARNING_MESSAGE_CONTACT_REP_DUCATI =
    'Payments.WarningMessage.ContactRepDucati';

export const PORTFOLIO_TITLE_LABEL = 'Portfolio.title';
export const PORTFOLIO_CUSTOMER_LABEL = 'Portfolio.customerLabel';
export const PORTFOLIO_ACCOUNT_LABEL = 'Portfolio.accountLabel';
export const PORTFOLIO_BASE_PAYMENT_LABEL = 'Portfolio.basePaymentLabel';
export const PORTFOLIO_EST_EQUITY_LABEL = 'Portfolio.estimatedEquityLabel';
export const PORTFOLIO_CURRT_MATURITY_LABEL = 'Portfolio.currentMatirutyLabel';
export const PORTFOLIO_PAY_DATE_LABEL = 'Portfolio.payoffDateLabel';
export const PORTFOLIO_MODEL_LABEL = 'Portfolio.modelLabel';
export const PORTFOLIO_ACCT_TYPE_LABEL = 'Portfolio.accTypeLabel';
export const PORTFOLIO_PROGRAM_LABEL = 'Portfolio.programLabel';
export const PORTFOLIO_NONE_LABEL = 'Portfolio.noneLabel';
export const PORTFOLIO_ACTIVE_CONTRACTS = 'Portfolio.activeContractsLabel';
export const PORTFOLIO_TERMINATED_CONTRACTS =
    'Portfolio.terminatedContractsLabel';
export const PORTFOLIO_LOAN = 'Portfolio.Loan';
export const PORTFOLIO_LEASE = 'Portfolio.Lease';
export const PORTFOLIO_VW_SELECT = 'Portfolio.VWSelect';
export const PORTFOLIO_AUDI_SELECT = 'Portfolio.AudiSelect';
export const PORTFOLIO_SEARCH_LABEL = 'Portfolio.searchLabel';
export const PORTFOLIO_MESSAGE_LABEL = 'Portfolio.errorMessage';
export const PORTFOLIO_SEARCH_TOOLTIP = 'Portfolio.Search.Tooltip';
export const PORTFOLIO_SEARCH_BY_NAME_TOOLTIP = 'Portfolio.Search.NameTooltip';
export const PORTFOLIO_SEARCH_BY_SPECIAL_TOOLTIP =
    'Portfolio.Search.SpecialTooltip';
export const PORTFOLIO_SEARCH_MONTHS_3 = 'Portfolio.Search.Months.3';
export const PORTFOLIO_SEARCH_MONTHS_6 = 'Portfolio.Search.Months.6';
export const PORTFOLIO_SEARCH_MONTHS_9 = 'Portfolio.Search.Months.9';
export const PORTFOLIO_SEARCH_MONTHS_12 = 'Portfolio.Search.Months.12';
export const PORTFOLIO_SEARCH_PROGRAMS_TITLE =
    'Portfolio.Search.Programs.Title';
export const PORTFOLIO_SEARCH_DATE_TITLE = 'Portfolio.Search.Date.Title';

export const PAYMENT_DETAILS_FUNDS_ERROR_MESSAGE =
    'Payments.Details.FundsTransferError';
export const PAYMENT_DETAILS_FUNDS_WARNING_MESSAGE =
    'Payments.Details.FundsTransferWarning';

export const RESERVES_TITLE = 'Reserves.Title';
export const RESERVES_SEARCH_BAR = 'Reserves.SearchBar';
export const RESERVES_NO_RESULTS = 'Reserves.NoResults';
export const RESERVES_FILTER_JANUARY = 'Reserves.Filters.January';
export const RESERVES_FILTER_FEBRUARY = 'Reserves.Filters.February';
export const RESERVES_FILTER_MARCH = 'Reserves.Filters.March';
export const RESERVES_FILTER_APRIL = 'Reserves.Filters.April';
export const RESERVES_FILTER_MAY = 'Reserves.Filters.May';
export const RESERVES_FILTER_JUNE = 'Reserves.Filters.June';
export const RESERVES_FILTER_JULY = 'Reserves.Filters.July';
export const RESERVES_FILTER_AUGUST = 'Reserves.Filters.August';
export const RESERVES_FILTER_SEPTEMBER = 'Reserves.Filters.September';
export const RESERVES_FILTER_OCTOBER = 'Reserves.Filters.October';
export const RESERVES_FILTER_NOVEMBER = 'Reserves.Filters.November';
export const RESERVES_FILTER_DECEMBER = 'Reserves.Filters.December';
export const RESERVES_FILTER_RESET = 'Reserves.Reset';
export const RESERVES_TABS_MONTHLY = 'Reserves.Tabs.Monthly';
export const RESERVES_TABS_ACTIVITY = 'Reserves.Tabs.Activity';
export const RESERVES_MONTHLY_HEADER = 'Reserves.Monthly.Header';
export const RESERVES_MONTHLY_FOR = 'Reserves.Monthly.For';
export const RESERVES_ACTIVITY_HEADER = 'Reserves.Activity.Header';
export const RESERVES_MONTHLY_MESSAGE = 'Reserves.Monthly.Message';
export const RESERVES_MONTHLY_TOTALS_HEADER = 'Reserves.Monthly.Totals.Header';
export const RESERVES_MONTHLY_TOTALS_DESCRIPTION =
    'Reserves.Monthly.Totals.Description';
export const RESERVES_MONTHLY_TOTALS_CREDITS =
    'Reserves.Monthly.Totals.Credits';
export const RESERVES_MONTHLY_TOTALS_STARTBALANCE =
    'Reserves.Monthly.Totals.StartBalance';
export const RESERVES_MONTHLY_TOTALS_EARNINGS =
    'Reserves.Monthly.Totals.DealerEarnings';
export const RESERVES_MONTHLY_TOTALS_ENDBALANCE =
    'Reserves.Monthly.Totals.EndBlance';
export const RESERVES_MONTHLY_TOTALS_BACKAMOUNT =
    'Reserves.Monthly.Totals.BackAmount';
export const RESERVES_MONTHLY_TOTALS_ADJUSTMENT_US =
    'Reserves.Monthly.Totals.AdjustmentAmount.US';
export const RESERVES_MONTHLY_TOTALS_ADJUSTMENT_CA =
    'Reserves.Monthly.Totals.AdjustmentAmount.CA';
export const RESERVES_MONTHLY_TOTALS_TRANSFER =
    'Reserves.Monthly.Totals.TransferAmount';
export const RESERVES_MONTHLY_TOTALS_REPOSSESSION =
    'Reserves.Monthly.Totals.RepossessionAmount';
export const RESERVES_MONTHLY_TOTALS_CHARGEOFF =
    'Reserves.Monthly.Totals.ChargeOffAmount';
export const RESERVES_MONTHLY_TOTALS_PAYOFF_US =
    'Reserves.Monthly.Totals.PayoffAmount.US';
export const RESERVES_MONTHLY_TOTALS_PAYOFF_CA =
    'Reserves.Monthly.Totals.PayoffAmount.CA';
export const RESERVES_MONTHLY_TOTALS_OUTSTANDING =
    'Reserves.Monthly.Totals.OutstandingBalance';
export const RESERVES_MONTHLY_TOTALS_RETENTION =
    'Reserves.Monthly.Totals.RetentionAmount';
export const RESERVES_MONTHLY_TOTALS_DISBURSEMENT =
    'Reserves.Monthly.Totals.Disbursement';
export const RESERVES_MONTHLY_TOTALS_DISBURSEMENTAMT =
    'Reserves.Monthly.Totals.DisbursementAmount';
export const RESERVES_MONTHLY_YEARLY_HEADER = 'Reserves.Monthly.Yearly.Header';
export const RESERVES_MONTHLY_YEARLY_DESCRIPTION =
    'Reserves.Monthly.Yearly.Description';
export const RESERVES_MONTHLY_YEARLY_CREDITS =
    'Reserves.Monthly.Yearly.Credits';
export const RESERVES_MONTHLY_YEARLY_EARNINGS =
    'Reserves.Monthly.Yearly.DealerEarnings';
export const RESERVES_MONTHLY_YEARLY_CHARGEBACK =
    'Reserves.Monthly.Yearly.ChargeBack';
export const RESERVES_MONTHLY_YEARLY_ADJUSTMENT =
    'Reserves.Monthly.Yearly.AdjustmentAmount';
export const RESERVES_MONTHLY_YEARLY_TRANSFER =
    'Reserves.Monthly.Yearly.TransferAmount';
export const RESERVES_MONTHLY_YEARLY_DISBURSMENTS =
    'Reserves.Monthly.Yearly.Disbursments';
export const RESERVES_MONTHLY_YEARLY_NOTE = 'Reserves.Monthly.Yearly.Note';
export const RESERVES_MONTHLY_YEARLY_MESSAGE =
    'Reserves.Monthly.Yearly.Message';
export const RESERVES_ACTIVITY_MESSAGE = 'Reserves.Activity.Message';
export const RESERVES_TABLE_ACCOUNT = 'Reserves.Table.AccountNumber';
export const RESERVES_TABLE_CUSTOMER = 'Reserves.Table.CustomerName';
export const RESERVES_TABLE_VIN = 'Reserves.Table.VIN';
export const RESERVES_TABLE_TRANSACTION = 'Reserves.Table.TransactrionType';
export const RESERVES_TABLE_FINANCE = 'Reserves.Table.AmountFinanced';
export const RESERVES_TABLE_PAYMENT = 'Reserves.Table.Payment';
export const RESERVES_TABLE_EOM = 'Reserves.Table.Eom';
export const DOCUMENTS_VIEW_TITLE = 'Documents.Title';
export const DOCUMENTS_VIEW_ERROR = 'Documents.Error';
export const DOCUMENTS_VIEW_TABS_GENERAL = 'Documents.Tabs.General';
export const DOCUMENTS_VIEW_TABS_POLICIES = 'Documents.Tabs.Policies';
export const DOCUMENTS_VIEW_TABS_FUNDING = 'Documents.Tabs.Funding';
export const DOCUMENTS_VIEW_TABS_CREDIT = 'Documents.Tabs.Credit';
export const DOCUMENTS_VIEW_TABS_TRANSFER = 'Documents.Tabs.Transfer';
export const DOCUMENTS_VIEW_TABS_END = 'Documents.Tabs.End';
export const DOCUMENTS_VIEW_NAMES_FINANCING = 'Documents.Names.Financing';
export const DOCUMENTS_VIEW_NAMES_CERT = 'Documents.Names.Certification';
export const DOCUMENTS_VIEW_NAMES_EN = 'Documents.Names.EN';
export const DOCUMENTS_VIEW_NAMES_FR = 'Documents.Names.FR';
export const DOCUMENTS_VIEW_NAMES_CCA = 'Documents.Names.CCA';
export const DOCUMENTS_VIEW_NAMES_CCAQ = 'Documents.Names.CCAQ';
export const DOCUMENTS_VIEW_NAMES_CCAR = 'Documents.Names.CCAR';
export const DOCUMENTS_VIEW_NAMES_CCAQC = 'Documents.Names.CCAQC';
export const DOCUMENTS_VIEW_NAMES_DOCUMENTCHECK =
    'Documents.Names.DocumentCheck';
export const DOCUMENTS_VIEW_NAMES_LEASE = 'Documents.Names.Lease';
export const DOCUMENTS_VIEW_NAMES_RETAIL = 'Documents.Names.Retail';
export const DOCUMENTS_VIEW_NAMES_WORKSHEETS = 'Documents.Names.Worksheets';
export const DOCUMENTS_VIEW_NAMES_ONEPAY = 'Documents.Names.OnePay';
export const DOCUMENTS_VIEW_NAMES_VWSELECT = 'Documents.Names.VWSelect';
export const DOCUMENTS_VIEW_NAMES_AUDISELECT = 'Documents.Names.AudiSelect';
export const DOCUMENTS_VIEW_NAMES_INSURANCE = 'Documents.Names.Insurance';
export const DOCUMENTS_VIEW_NAMES_PREFORM = 'Documents.Names.PreForm';
export const DOCUMENTS_VIEW_NAMES_CORPORATE = 'Documents.Names.Corporate';
export const DOCUMENTS_VIEW_NAMES_LPA = 'Documents.Names.LPA';
export const DOCUMENTS_VIEW_NAMES_REFUNDABLE = 'Documents.Names.Refundable';
export const DOCUMENTS_VIEW_NAMES_LEASETERM = 'Documents.Names.LeaseTerm';
export const DOCUMENTS_VIEW_NAMES_LEASEWORK = 'Documents.Names.LeaseWork';
export const DOCUMENTS_VIEW_NAMES_LEASECHECK = 'Documents.Names.LeaseChecklist';
export const DOCUMENTS_VIEW_NAMES_CUSTOMER =
    'Documents.Names.CustomerIdentification';

export const DOCUMENTS_VIEW_TABS_PAYOFF = 'Documents.Tabs.Payoff';
export const DOCUMENTS_VIEW_TABS_MISCELLANEOUS = 'Documents.Tabs.Miscellaneous';

export const DOCUMENTS_VIEW_NAMES_BCA = 'Documents.Names.BCA';
export const DOCUMENTS_VIEW_NAMES_CONSUMER_CREDIT_US =
    'Documents.Names.ConsumerCreditUS';
export const DOCUMENTS_VIEW_NAMES_EMPLOYMENT_VERIFICATION =
    'Documents.Names.EmploymentVerification';
export const DOCUMENTS_VIEW_NAMES_FOREIGN_BUSINESS =
    'Documents.Names.ForeignBusiness';
export const DOCUMENTS_VIEW_NAMES_PERSONAL_REF = 'Documents.Names.PersonalRef';
export const DOCUMENTS_VIEW_NAMES_ORDER_SUPPLIES =
    'Documents.Names.OrderSupplies';
export const DOCUMENTS_VIEW_NAMES_SPEEDY_FAX = 'Documents.Names.SpeedyFax';
export const DOCUMENTS_VIEW_NAMES_CONSUMER_AUTO_PAYMENT =
    'Documents.Names.ConsumerAutoPayment';
export const DOCUMENTS_VIEW_NAMES_AUTOPAYMENT_CANCEL =
    'Documents.Names.AutopaymentCancel';
export const DOCUMENTS_VIEW_NAMES_SC_TAX_CREDIT = 'Documents.Names.SCTaxCredit';
export const DOCUMENTS_VIEW_NAMES_WI_TAX_CREDIT = 'Documents.Names.WITaxCredit';
export const DOCUMENTS_VIEW_NAMES_IL_INTERPRETER =
    'Documents.Names.ILInterpreter';
export const DOCUMENTS_VIEW_NAMES_CT_TRADEIN = 'Documents.Names.CTTradeIn';
export const DOCUMENTS_VIEW_NAMES_ID_VERIFICATION =
    'Documents.Names.IDVerification';
export const DOCUMENTS_VIEW_NAMES_NOTICE_COSIGNER_RETAIL =
    'Documents.Names.NoticeCosignerRetail';
export const DOCUMENTS_VIEW_NAMES_NOTICE_COSIGNER_LEASE =
    'Documents.Names.NoticeCosignerLease';
export const DOCUMENTS_VIEW_NAMES_NOTICE_COSIGNER_FORMS =
    'Documents.Names.NoticeCosignerForms';
export const DOCUMENTS_VIEW_NAMES_EV_LEASE_ADDENDUM =
    'Documents.Names.EVLeaseAddendum';
export const DOCUMENTS_VIEW_NAMES_EV_DSL_ADDENDUM =
    'Documents.Names.EVDSLAddendum';
export const DOCUMENTS_VIEW_NAMES_FUNDING_OTHER =
    'Documents.Names.FundingOther';
export const DOCUMENTS_VIEW_NAMES_EV_BUNDLE_ACK = 'Documents.Names.EVBundleAck';
export const DOCUMENTS_VIEW_NAMES_FUNDING_CHECKLIST =
    'Documents.Names.FundingChecklist';
export const DOCUMENTS_VIEW_NAMES_DEALER_RESERVE =
    'Documents.Names.DealerReserve';
export const DOCUMENTS_VIEW_NAMES_BONUS_RESEARCH =
    'Documents.Names.BonusResearch';
export const DOCUMENTS_VIEW_NAMES_LAW_PRINTING_ORDER =
    'Documents.Names.LawPrintingOrder';
export const DOCUMENTS_VIEW_NAMES_INSURANCE_FORM_US =
    'Documents.Names.InsuranceFormUS';
export const DOCUMENTS_VIEW_NAMES_ODOMETER = 'Documents.Names.Odometer';
export const DOCUMENTS_VIEW_NAMES_NEW_MEXICO_INSURANCE =
    'Documents.Names.NewMexicoInsurance';
export const DOCUMENTS_VIEW_NAMES_AUDI_CARE_FORMS =
    'Documents.Names.AudiCareForms';
export const DOCUMENTS_VIEW_NAMES_NM_INSURANCE_ALL_RETAILS =
    'Documents.Names.NMInsuranceAllRetails';
export const DOCUMENTS_VIEW_NAMES_NM_INSURANCE_DEALER_AUTH =
    'Documents.Names.NMInsuranceDealerAuth';
export const DOCUMENTS_VIEW_NAMES_AUDI_CARE = 'Documents.Names.AudiCare';
export const DOCUMENTS_VIEW_NAMES_AUDI_CARE_CA = 'Documents.Names.AudiCareCA';

export const SYSTEM_ADMIN_TITLE = 'SystemAdmin.Title';
export const SYSTEM_ADMIN_TABS_INTERNAL = 'SystemAdmin.Tabs.Internal';
export const SYSTEM_ADMIN_TABS_CONTENT = 'SystemAdmin.Tabs.Content';
export const SYSTEM_ADMIN_DEALER_MANAGEMENT = 'SystemAdmin.DealerManagement';
export const SYSTEM_ADMIN_DEALER_ACTIVATION = 'SystemAdmin.DealerActivation';
export const SYSTEM_ADMIN_DEALER_SECURITY_MAINTENANCE =
    'SystemAdmin.DealerSecurityMaintenance';
export const SYSTEM_ADMIN_DEALER_GROUP_MAINTENANCE =
    'SystemAdmin.DealerGroupMaintenance';
export const SYSTEM_ADMIN_ACCESS_SECURITY = 'SystemAdmin.AccessAndSecurity';
export const SYSTEM_ADMIN_INTERNAL_TOOLS = 'SystemAdmin.InternalTools';
export const SYSTEM_ADMIN_FIELD_USER_MANAGEMENT =
    'SystemAdmin.FieldUserManagement';
export const SYSTEM_ADMIN_INTERNAL_SECURITY_MAINTENANCE =
    'SystemAdmin.InternalSecurityMaintenance';
export const SYSTEM_ADMIN_DATE_AND_TERM_CHANGE =
    'SystemAdmin.DateAndTermChange';
export const SYSTEM_ADMIN_DOCUMENTS_HEADING = 'SystemAdmin.DocumentsHeading';
export const SYSTEM_ADMIN_STATIC_PDF_MAINTENANCE =
    'SystemAdmin.StaticPDFMaintenance';
export const SYSTEM_ADMIN_DISTRIBUTION_RULE_MANAGEMENT =
    'SystemAdmin.DistributionRuleManagement';
export const SYSTEM_ADMIN_CREATE_NEW_RULE = 'SystemAdmin.CreateNewRule';
export const SYSTEM_ADMIN_VIEW_EDIT_EXISTING_RULE =
    'SystemAdmin.ViewEditExistingRule';
export const SYSTEM_ADMIN_DIST_RULE_PAGE_TITLE =
    'SystemAdmin.ViewDistributionRulePage.Title';
export const SYSTEM_ADMIN_DIST_RULE_PAGE_DESCRIPTION =
    'SystemAdmin.ViewDistributionRulePage.Description';
export const SYSTEM_ADMIN_DIST_RULE_SEARCH_PLACEHOLDER =
    'SystemAdmin.ViewDistributionRulePage.SearchPlaceholder';
export const SYSTEM_ADMIN_DIST_RULE_SEARCH_BTN =
    'SystemAdmin.ViewDistributionRulePage.SearchButton';
export const SYSTEM_ADMIN_DIST_RULE_CREATE_BTN =
    'SystemAdmin.ViewDistributionRulePage.CreateButton';
export const SYSTEM_ADMIN_DIST_RULE_CLOSE_BTN =
    'SystemAdmin.ViewDistributionRulePage.CloseButton';
export const SYSTEM_ADMIN_DIST_RULE_COL_RULE_NAME =
    'SystemAdmin.ViewDistributionRulePage.ColumnRuleName';
export const SYSTEM_ADMIN_DIST_RULE_COL_CREATED_BY =
    'SystemAdmin.ViewDistributionRulePage.ColumnCreatedBy';
export const SYSTEM_ADMIN_DIST_RULE_COL_CREATED_DATE =
    'SystemAdmin.ViewDistributionRulePage.ColumnCreatedDate';
export const SYSTEM_ADMIN_DIST_RULE_COL_MODIFIED_DATE =
    'SystemAdmin.ViewDistributionRulePage.ColumnModifiedDate';
export const SYSTEM_ADMIN_DIST_RULE_MENU_VIEW_EDIT =
    'SystemAdmin.ViewDistributionRulePage.MenuViewEdit';
export const SYSTEM_ADMIN_DIST_RULE_MENU_DELETE =
    'SystemAdmin.ViewDistributionRulePage.MenuDelete';
export const SYSTEM_ADMIN_DIST_RULE_DELETE_MODAL_TITLE =
    'SystemAdmin.ViewDistributionRulePage.DeleteModal.Title';
export const SYSTEM_ADMIN_DIST_RULE_DELETE_MODAL_BODY =
    'SystemAdmin.ViewDistributionRulePage.DeleteModal.Body';
export const SYSTEM_ADMIN_DIST_RULE_DELETE_MODAL_CANCEL =
    'SystemAdmin.ViewDistributionRulePage.DeleteModal.Cancel';
export const SYSTEM_ADMIN_DIST_RULE_DELETE_MODAL_CONFIRM =
    'SystemAdmin.ViewDistributionRulePage.DeleteModal.Confirm';
export const SYSTEM_ADMIN_DIST_RULE_DELETE_SUCCESS =
    'SystemAdmin.ViewDistributionRulePage.DeleteSuccess';
export const SYSTEM_ADMIN_DIST_RULE_DELETE_IN_USE =
    'SystemAdmin.ViewDistributionRulePage.DeleteInUse';
export const SYSTEM_ADMIN_DIST_RULE_DELETE_ERROR =
    'SystemAdmin.ViewDistributionRulePage.DeleteError';
export const SYSTEM_ADMIN_DIST_RULE_NO_RESULTS =
    'SystemAdmin.ViewDistributionRulePage.NoResults';
export const SYSTEM_ADMIN_DIST_RULE_ERROR =
    'SystemAdmin.ViewDistributionRulePage.Error';
export const SYSTEM_ADMIN_DIST_RULE_SELECT_MODE_BANNER =
    'SystemAdmin.ViewDistributionRulePage.SelectModeBanner';
export const SYSTEM_ADMIN_DIST_RULE_ADD_SELECTED_RULE_BTN =
    'SystemAdmin.ViewDistributionRulePage.AddSelectedRuleButton';
export const SYSTEM_ADMIN_DIST_RULE_SELECT_CANCEL_BTN =
    'SystemAdmin.ViewDistributionRulePage.SelectCancelButton';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_RULE_NAME_LABEL =
    'SystemAdmin.CreateRulePage.RuleNameLabel';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_TITLE =
    'SystemAdmin.CreateRulePage.Title';
export const SYSTEM_ADMIN_EDIT_RULE_PAGE_TITLE =
    'SystemAdmin.CreateRulePage.EditTitle';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_DESCRIPTION =
    'SystemAdmin.CreateRulePage.Description';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_RULE_NAME_PLACEHOLDER =
    'SystemAdmin.CreateRulePage.RuleNamePlaceholder';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_SCOPE_LABEL =
    'SystemAdmin.CreateRulePage.ScopeLabel';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_SCOPE_REGION_DISTRICT =
    'SystemAdmin.CreateRulePage.ScopeRegionDistrict';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_SCOPE_STATE_PROVINCE =
    'SystemAdmin.CreateRulePage.ScopeStateProvince';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_SCOPE_DEALERSHIP =
    'SystemAdmin.CreateRulePage.ScopeDealership';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_REGION_LABEL =
    'SystemAdmin.CreateRulePage.RegionLabel';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_COUNTRY_PLACEHOLDER =
    'SystemAdmin.CreateRulePage.CountryPlaceholder';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_BRAND_PLACEHOLDER =
    'SystemAdmin.CreateRulePage.BrandPlaceholder';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_COUNTRY_OPTION_USA =
    'SystemAdmin.CreateRulePage.CountryOptionUSA';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_COUNTRY_OPTION_CANADA =
    'SystemAdmin.CreateRulePage.CountryOptionCanada';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_BRAND_OPTION_VW =
    'SystemAdmin.CreateRulePage.BrandOptionVW';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_BRAND_OPTION_VW_AND_AUDI =
    'SystemAdmin.CreateRulePage.BrandOptionVWAndAudi';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_BRAND_OPTION_ANY =
    'SystemAdmin.CreateRulePage.BrandOptionAny';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_BRAND_OPTION_AUDI =
    'SystemAdmin.CreateRulePage.BrandOptionAudi';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_BRAND_OPTION_DUCATI =
    'SystemAdmin.CreateRulePage.BrandOptionDucati';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_REGION_PLACEHOLDER =
    'SystemAdmin.CreateRulePage.RegionPlaceholder';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_DISTRICT_LABEL =
    'SystemAdmin.CreateRulePage.DistrictLabel';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_DISTRICT_PLACEHOLDER =
    'SystemAdmin.CreateRulePage.DistrictPlaceholder';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_STATE_PROVINCE_LABEL =
    'SystemAdmin.CreateRulePage.StateProvinceLabel';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_STATE_PROVINCE_PLACEHOLDER =
    'SystemAdmin.CreateRulePage.StateProvincePlaceholder';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_STATE_PROVINCE_HELP_TEXT =
    'SystemAdmin.CreateRulePage.StateProvinceHelpText';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_DEALERSHIP_LABEL =
    'SystemAdmin.CreateRulePage.DealershipLabel';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_DEALERSHIP_PLACEHOLDER =
    'SystemAdmin.CreateRulePage.DealershipPlaceholder';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_RULE_TYPE_TITLE =
    'SystemAdmin.CreateRulePage.RuleTypeTitle';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_RULE_TYPE_DESCRIPTION =
    'SystemAdmin.CreateRulePage.RuleTypeDescription';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_REGION_HELP_TEXT =
    'SystemAdmin.CreateRulePage.RegionHelpText';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_DISTRICT_HELP_TEXT =
    'SystemAdmin.CreateRulePage.DistrictHelpText';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_BACK_BUTTON =
    'SystemAdmin.CreateRulePage.BackButton';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_SAVE_BUTTON =
    'SystemAdmin.CreateRulePage.SaveButton';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_CANCEL_BUTTON =
    'SystemAdmin.CreateRulePage.CancelButton';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_LOAD_REGION_ERROR =
    'SystemAdmin.CreateRulePage.LoadRegionError';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_LOAD_DISTRICT_ERROR =
    'SystemAdmin.CreateRulePage.LoadDistrictError';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_SUCCESS_MESSAGE =
    'SystemAdmin.CreateRulePage.SuccessMessage';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_UPDATE_SUCCESS_MESSAGE =
    'SystemAdmin.CreateRulePage.UpdateSuccessMessage';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_LOAD_RULE_DETAILS_ERROR =
    'SystemAdmin.CreateRulePage.LoadRuleDetailsError';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_MULTIPLE_VALUES_SELECTED =
    'SystemAdmin.CreateRulePage.MultipleValuesSelected';
export const SYSTEM_ADMIN_CREATE_RULE_PAGE_SELECTED_COUNT_SUFFIX =
    'SystemAdmin.CreateRulePage.SelectedCountSuffix';
export const SYSTEM_ADMIN_PAGE_ACTIVATE_DEALER_TITLE =
    'SystemAdmin.DealerActivationPage.Title';
export const SYSTEM_ADMIN_PAGE_ACTIVATE_DEALER_TITLE_BUTTON =
    'SystemAdmin.DealerActivationPage.ButtonTittle';
export const SYSTEM_ADMIN_PAGE_ACTIVATE_DEALER_TITLE_LABEL =
    'SystemAdmin.DealerActivationPage.LabelTittle';
export const SYSTEM_ADMIN_PAGE_ACTIVATE_DEALER_DESC =
    'SystemAdmin.DealerActivationPage.Description';
export const SYSTEM_ADMIN_PAGE_ACTIVATE_DEALER_MSG_SUCC =
    'SystemAdmin.DealerActivationPage.SuccessMessage';
export const SYSTEM_ADMIN_PAGE_ACTIVATE_DEALER_MSG_ERR1 =
    'SystemAdmin.DealerActivationPage.ErrorMessage1';
export const SYSTEM_ADMIN_PAGE_ACTIVATE_DEALER_MGS_ERR2 =
    'SystemAdmin.DealerActivationPage.ErrorMessage2';
export const SYSTEM_ADMIN_PAGE_STATIC_PDF_INFO =
    'SystemAdmin.StaticPDFMaintenancePage.Info';
export const SYSTEM_ADMIN_PAGE_STATIC_PDF_INFO2 =
    'SystemAdmin.StaticPDFMaintenancePage.Info2';
export const SYSTEM_ADMIN_PAGE_UPLOAD_BTN = 'SystemAdmin.UploadLabel';
export const SYSTEM_ADMIN_PAGE_ADD_BTN = 'SystemAdmin.AddLabel';
export const SYSTEM_ADMIN_PAGE_UPLOAD_DOC_BTN = 'SystemAdmin.UploadDocLabel';
export const SYSTEM_ADMIN_PAGE_DESCRIPTION_LABEL =
    'SystemAdmin.DescriptionLabel';
export const SYSTEM_ADMIN_PAGE_NO_ALLOWED = 'SystemAdmin.NoAllowedSizeLabel';
export const SYSTEM_ADMIN_PAGE_SUCC_MSG = 'SystemAdmin.SuccessMsg';
export const SYSTEM_ADMIN_PAGE_ERR_MSG = 'SystemAdmin.ErrorMsg';
export const SYSTEM_ADMIN_PAGE_PROCESS_LABEL = 'SystemAdmin.ProcessingLabel';
export const SYSTEM_ADMIN_PAGE_VIEW_BTN = 'SystemAdmin.ViewLabel';
export const SYSTEM_ADMIN_PAGE_BRAND_LABEL = 'SystemAdmin.BrandLabel';
export const SYSTEM_ADMIN_PAGE_COUNTRY_LABEL = 'SystemAdmin.CountryLabel';
export const SYSTEM_ADMIN_PAGE_BY_LABEL = 'SystemAdmin.ByLabel';
export const SYSTEM_ADMIN_PAGE_DATE_LABEL = 'SystemAdmin.DateLabel';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_TITLE =
    'SystemAdmin.DateAndTermChangePage.Title';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_DESCRIPTION =
    'SystemAdmin.DateAndTermChangePage.Description';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_COUNTRY_LABEL =
    'SystemAdmin.DateAndTermChangePage.CountryLabel';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_COUNTRY_USA =
    'SystemAdmin.DateAndTermChangePage.CountryUSA';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_COUNTRY_CANADA =
    'SystemAdmin.DateAndTermChangePage.CountryCanada';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_CURRENTLY_SET_TEXT =
    'SystemAdmin.DateAndTermChangePage.CurrentlySetText';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_DATE_LABEL =
    'SystemAdmin.DateAndTermChangePage.DateLabel';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_CANCEL_BUTTON =
    'SystemAdmin.DateAndTermChangePage.CancelButton';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_SUBMIT_BUTTON =
    'SystemAdmin.DateAndTermChangePage.SubmitButton';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_REQUIRED_ERROR =
    'SystemAdmin.DateAndTermChangePage.RequiredError';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_INVALID_DATE_ERROR =
    'SystemAdmin.DateAndTermChangePage.InvalidDateError';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_SUCCESS_MESSAGE =
    'SystemAdmin.DateAndTermChangePage.SuccessMessage';
export const SYSTEM_ADMIN_DATE_TERM_PAGE_SYSTEM_ERROR_MESSAGE =
    'SystemAdmin.DateAndTermChangePage.SystemErrorMessage';
export const SYSTEM_ADMIN_BULLETINS_SECTION = 'SystemAdmin.BulletinsSection';
export const SYSTEM_ADMIN_BULLETINS_UPLOAD_LINK =
    'SystemAdmin.BulletinsUploadLink';
export const SYSTEM_ADMIN_BULLETINS_VIEW_LINK = 'SystemAdmin.BulletinsViewLink';
export const SYSTEM_ADMIN_COU_SECTION = 'SystemAdmin.CouSection';
export const SYSTEM_ADMIN_COU_CREATE_LINK = 'SystemAdmin.CouCreateLink';
export const SYSTEM_ADMIN_COU_VIEW_LINK = 'SystemAdmin.CouViewLink';
export const SYSTEM_ADMIN_COU_LEAVE_MODAL_TITLE =
    'SystemAdmin.CriticalOrganizationUpdates.LeaveModalTitle';
export const SYSTEM_ADMIN_COU_LEAVE_MODAL_BODY =
    'SystemAdmin.CriticalOrganizationUpdates.LeaveModalBody';
export const SYSTEM_ADMIN_COU_LEAVE_MODAL_CANCEL =
    'SystemAdmin.CriticalOrganizationUpdates.LeaveModalCancel';
export const SYSTEM_ADMIN_COU_LEAVE_MODAL_CONFIRM =
    'SystemAdmin.CriticalOrganizationUpdates.LeaveModalConfirm';
export const SYSTEM_ADMIN_VEHICLE_MANAGER_SECTION =
    'SystemAdmin.VehicleManagerSection';
export const SYSTEM_ADMIN_VEHICLE_UPLOAD_LINK = 'SystemAdmin.VehicleUploadLink';
export const SYSTEM_ADMIN_VEHICLE_SEARCH_LINK = 'SystemAdmin.VehicleSearchLink';
export const PAYOFF_QUOTE_DETAILS_ONLINE_PAYMENT_TITLE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.OnlinePayment.Title';
export const PAYOFF_QUOTE_DETAILS_ONLINE_PAYMENT_INFO =
    'Payments.PayoffQuotes.Detail.QuoteDetails.OnlinePayment.Info';
export const PAYOFF_QUOTE_DETAILS_ONLINE_PAYMENT_INFO2 =
    'Payments.PayoffQuotes.Detail.QuoteDetails.OnlinePayment.Info2';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_INFO_RETAIL =
    'Payments.PayoffQuotes.Detail.QuoteDetails.AccountInfo.Retail';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_INFO_LEASE =
    'Payments.PayoffQuotes.Detail.QuoteDetails.AccountInfo.Lease';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_INFO_MATURITY =
    'Payments.PayoffQuotes.Detail.QuoteDetails.AccountInfo.Maturity';
export const PAYOFF_QUOTE_DETAILS_ACCOUNT_INFO_TOTAL =
    'Payments.PayoffQuotes.Detail.QuoteDetails.AccountInfo.TotalPayout';
export const TITLE_REQUEST_ADDRESS_LINE1_ERROR =
    'TitleRequest.AddressLine1Error';
export const TITLE_REQUEST_ADDRESS_LINE2_ERROR =
    'TitleRequest.AddressLine2Error';
export const TITLE_REQUEST_CITY_ERROR = 'TitleRequest.CityError';
export const TITLE_REQUEST_SPECIAL_INSTRUCTIONS_ERROR =
    'TitleRequest.SpecialInstructionsError';
export const TITLE_REQUEST_PDF_SIZE_ERROR = 'TitleRequest.PdfSizeError';
export const QUICKFUND_TITLE = 'QuickFund.Title';
export const QUICKFUND_DETAILS_TITLE = 'QuickFund.DetailsTitle';
export const QUICKFUND_NOTE1 = 'QuickFund.Note1';
export const QUICKFUND_NOTE2 = 'QuickFund.Note2';
export const QUICKFUND_NOTE3 = 'QuickFund.Note3';

// QuickFund ApplicationInformation
export const QUICKFUND_APP_INFO_TITLE =
    'QuickFund.ApplicationInformation.Title';
export const QUICKFUND_APP_INFO_PRIMARY_APPLICANT =
    'QuickFund.ApplicationInformation.PrimaryApplicant';
export const QUICKFUND_APP_INFO_VEHICLE =
    'QuickFund.ApplicationInformation.Vehicle';
export const QUICKFUND_APP_INFO_AMOUNT_TO_FINANCE =
    'QuickFund.ApplicationInformation.AmountToFinance';
export const QUICKFUND_APP_INFO_CONTRACT_TYPE =
    'QuickFund.ApplicationInformation.ContractType';
export const QUICKFUND_APP_INFO_ADJUSTED_CAP_COST =
    'QuickFund.ApplicationInformation.AdjustedCapCost';
export const QUICKFUND_APP_INFO_BALLOON_CONTRACT =
    'QuickFund.ApplicationInformation.BalloonContract';

// QuickFund Messages
export const QUICKFUND_MESSAGES_LEARN = 'QuickFund.Messages.Learn';
export const QUICKFUND_MESSAGES_DUE = 'QuickFund.Messages.Due';
export const QUICKFUND_MESSAGES_ELIGIBLE_MESSAGE =
    'QuickFund.Messages.EligibleMessage';
export const QUICKFUND_MESSAGES_OPTION = 'QuickFund.Messages.Option';
export const QUICKFUND_MESSAGES_TRY_AGAIN_LATER =
    'QuickFund.Messages.TryAgainLater';
export const QUICKFUND_MESSAGES_NOT_ELIGIBLE_SEND_TO_VCI =
    'QuickFund.Messages.NotEligibleSendToVCI';
export const QUICKFUND_MESSAGES_DOES_NOT_QUALIFY =
    'QuickFund.Messages.DoesNotQualify';
export const QUICKFUND_MESSAGES_ALREADY_QUICK_FUNDED =
    'QuickFund.Messages.AlreadyQuickFunded';
export const QUICKFUND_MESSAGES_ELIGIBLE_WITH_CONTRACT =
    'QuickFund.Messages.EligibleWithContract';
export const QUICKFUND_MESSAGES_NOT_ELIGIBLE_DUE_TO_MISSING_OR_FAILED_CONTRACT =
    'QuickFund.Messages.NotEligibleDueToMissingOrFailedContract';
export const QUICKFUND_MESSAGES_VIEW_ONLY_PERMISSION =
    'QuickFund.Messages.ViewOnlyPermission';

// QuickFund Information
export const QUICKFUND_INFO_TITLE = 'QuickFund.Information.Title';
export const QUICKFUND_INFO_VIN = 'QuickFund.Information.Vin';
export const QUICKFUND_INFO_SECURITY_DEPOSIT =
    'QuickFund.Information.SecurityDeposit';
export const QUICKFUND_INFO_MONTHLY_PAYMENT =
    'QuickFund.Information.MonthlyPayment';
export const QUICKFUND_INFO_ACQUISITION_FEE =
    'QuickFund.Information.AcquisitionFee';
export const QUICKFUND_INFO_QUICKFUND_ADVANCE_AMOUNT =
    'QuickFund.Information.QuickFundAdvanceAmount';
export const QUICKFUND_INFO_REQUIRED = 'QuickFund.Information.Required';
export const QUICKFUND_INFO_QUICKFUND_ADVANCE_AMOUNT_TOOLTIP =
    'QuickFund.Information.QuickFundAdvanceAmountTooltip';
export const QUICKFUND_INFO_QUICKFUND_ADVANCE_AMOUNT_BALLOON_TOOLTIP =
    'QuickFund.Information.QuickFundAdvanceAmountBalloonTooltip';
export const QUICKFUND_INFO_NOTE = 'QuickFund.Information.Note';
export const QUICKFUND_INFO_SUBMIT_BTN = 'QuickFund.Information.SubmitBtn';
export const QUICKFUND_INFO_CANCEL_BTN = 'QuickFund.Information.CancelBtn';
export const QUICKFUND_INFO_AGREEMENT = 'QuickFund.Information.Agreement';
export const QUICKFUND_INFO_OTHER_AMOUNT = 'QuickFund.Information.OtherAmount';
export const QUICKFUND_INFO_OTHER_AMOUNT_ERROR =
    'QuickFund.Information.OtherAmountError';
export const QUICKFUND_INFO_SUCCESS_NOTIFICATION =
    'QuickFund.Information.SuccessNotification';
export const QUICKFUND_INFO_ERROR_NOTIFICATION =
    'QuickFund.Information.ErrorNotification';
export const QUICKFUND_INFO_CONTRACT = 'QuickFund.Information.Contract';
export const QUICKFUND_INFO_ADJUSTED_CAP_COST_ERROR =
    'QuickFund.Information.AdjustedCapCostError';
export const QUICKFUND_INFO_SECURITY_DEPOSIT_ERROR =
    'QuickFund.Information.SecurityDepositError';
export const QUICKFUND_INFO_MONTHLY_PAYMENT_ERROR =
    'QuickFund.Information.MonthlyPaymentError';
export const QUICKFUND_INFO_ACQUISITION_FEE_ERROR =
    'QuickFund.Information.AcquisitionFeeError';
export const QUICKFUND_INFO_VIN_ERROR = 'QuickFund.Information.VinError';
export const QUICKFUND_INFO_AMOUNT_FINANCED =
    'QuickFund.Information.AmountFinanced';
export const QUICKFUND_INFO_AMOUNT_FINANCED_TOOLTIP =
    'QuickFund.Information.AmountFinancedTooltip';
export const QUICKFUND_INFO_ADVANCE_AMOUNT_ERROR =
    'QuickFund.Information.QuickFundAdvanceAmountError';

// QuickFund Status
export const QUICKFUND_STATUS_TITLE = 'QuickFund.Status.Title';
export const QUICKFUND_STATUS_SUBMITTED = 'QuickFund.Status.Submitted';
export const QUICKFUND_STATUS_SUBMITTED_BY = 'QuickFund.Status.SubmittedBy';
export const QUICKFUND_STATUS_SUBMITTED_ON = 'QuickFund.Status.SubmittedOn';
export const QUICKFUND_STATUS_BULLETIN_NUMBER =
    'QuickFund.Status.BulletinNumber';
export const QUICKFUND_STATUS_CONTRACT_VALIDATION_NUMBER =
    'QuickFund.Status.ContractValidationNumber';

// Critical Organization Update
export const CRITICAL_ORGANIZATION_UPDATE_CLOSE =
    'CriticalOrganizationUpdate.Close';
export const CRITICAL_ORGANIZATION_UPDATE_READ_MORE =
    'CriticalOrganizationUpdate.ReadMore';
